<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showStartDate == '' && showEndDate == '') || (showStartDate != '' && showEndDate != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showStartDate != '' && showEndDate != '' && isShowDate == true
      }"
      :style="navbarWithName ? 'margin-left: 10px !important;' : ''"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicSentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          no-data-text="No topic available"
          dense
          outlined
          rounded
          @change="parameterProsesTopic"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="topicKeywordSentiment"
          v-model="selectedKeyword"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          no-data-text="No keyword available"
          dense
          outlined
          rounded
          @change="parameterProsesKeyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeBerita"
          item-text="name"
          item-value="value"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameterProsesPeriode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small dark width="120" color="var(--color-theme)">
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="startDate"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="endDate"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="var(--color-theme)" text @click="menu = false, parameterProsesCustom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showStartDate != '' && showEndDate != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showStartDate[1] + " " + showStartDate[0] + " " + showStartDate[2] }} - {{ showEndDate[1] + " " + showEndDate[0] + " " + showEndDate[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showStartDate == '' && showEndDate == '') || (showStartDate != '' && showEndDate != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showStartDate != '' && showEndDate != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, loadViral()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          style="max-width: 100%;"
          height="40"
          color="#a80202"
          variant="outlined"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
    </v-layout>

    <div v-if="devOrigins.includes(currentOrigin)" class="mb-8 d-flex justify-end">
      <v-btn
        class="d-flex align-center justify-space-between pa-0 px-2"
        :style="{
          position: 'fixed',
          bottom: '60px',
          right: '30px',
          'z-index': (dialogLoading || dialogSearchContext) ? 1 : 9999,
          'border-radius': '9999px'
        }"
        height="50"
        width="165"
        color="white"
        elevation="4"
        @click="postDescribeViral()"
      >
        <div
          class="d-flex align-center justify-center"
          :style="{ backgroundColor: 'var(--color-theme)', borderRadius: '50%', width: '36px', height: '36px' }"
        >
          <SparklesIcon class="w-4 h-4" style="color: white;" />
        </div>

        <div style="flex: 1; text-align: center;">
          <span style="text-transform: none; color: black; font-size: 14px;">
            Insights AI
          </span>
        </div>

        <v-icon
          :style="{
            'margin-top': dialogPageInsight ? '-3px' : '1px',
            transform: dialogPageInsight ? 'rotate(90deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease',
            color: 'black'
          }"
          size="18"
        >
          mdi-play
        </v-icon>
      </v-btn>
    </div>

    <v-layout row wrap>
      <v-flex lg7 sm12 xs12>
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" height="350px" flat>
            <v-row>
              <v-col cols="12" md="9">
                <div class="mt-2 ml-4 font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
                  Public Sentiment
                </div>
                <div class="ml-4 grey--text" style="font-size: 15px;">
                  Viral Post Sentiment Distribution
                </div>
                <v-card-subtitle class="mt-1" style="font-size: 22px; font-weight: 600; color: #405A78; font-family: Roboto; text-align: center;">
                  Social Media
                </v-card-subtitle>

                <v-row class="pl-2" no-gutters>
                  <v-col cols="4" class="text-center">
                    <div class="text-h4 font-weight-bold" style="color: #E0544C;">
                      {{ persenPublicSentimentNegative }}%
                    </div>
                    <div class="text-caption grey--text">
                      Negative
                    </div>
                  </v-col>

                  <v-col cols="4" class="text-center">
                    <div class="text-h4 font-weight-bold" style="color: #405A78;">
                      {{ persenPublicSentimentNeutral }}%
                    </div>
                    <div class="text-caption grey--text">
                      Neutral
                    </div>
                  </v-col>

                  <v-col cols="4" class="text-center">
                    <div class="text-h4 font-weight-bold" style="color: #4D9DC9;">
                      {{ persenPublicSentimentPositive }}%
                    </div>
                    <div class="text-caption grey--text">
                      Positive
                    </div>
                  </v-col>

                  <v-col cols="12" class="mt-n3">
                    <apexchart
                      :options="optionsPublicSentiment"
                      :series="seriesPublicSentiment"
                    ></apexchart>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="3">
                <v-row class="d-flex flex-column align-center">
                  <v-col
                    v-for="(item, index) in listSourceCollection"
                    :key="item.ID"
                    cols="12"
                    :class="listSourceCollection.length > 4 ? 'py-0' : 'py-1'"
                  >
                    <v-card
                      :class="[
                        'd-flex align-center justify-center',
                        listSourceCollection.length > 4 ? 'px-3 py-2' : 'px-4 py-3',
                        { 'mt-2': listSourceCollection.length > 4 && index != 0 }
                      ]"
                      :style="{
                        backgroundColor: cardColorsSourceCollection[index],
                        borderRadius: '28px',
                        color: 'white',
                        width: '180px',
                        height: listSourceCollection.length > 4 ? '62px' : '80px'
                      }"
                      flat
                    >
                      <div class="d-flex flex-column align-center" style="width: 100%;">
                        <div :class="['d-flex align-center', listSourceCollection.length > 4 ? 'mb-0' : 'mb-1']">
                          <v-icon :size="listSourceCollection.length > 4 ? 22 : 28" color="white" class="mr-2">
                            {{ item.ICON }}
                          </v-icon>
                          <div :style="{ fontSize: listSourceCollection.length > 4 ? '22px' : '28px', fontWeight: 600 }">
                            {{ getSourceCollectionTotal(item.NAME_COLLECTION) }}
                          </div>
                        </div>
                        <div :style="{ fontSize: listSourceCollection.length > 4 ? '13px' : '15px', whiteSpace: 'nowrap' }">
                          {{ getSourceCollectionLabel(item.NAME_COLLECTION) }}
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex lg5 sm12 xs12>
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" height="350px" flat>
            <div class="mt-2 ml-4 font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Source Breakdown
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Content Author Segmentation
            </div>

            <apexchart
              :options="optionsSourceBreakdown"
              :series="seriesSourceBreakdown"
              type="donut"
              width="450px"
            ></apexchart>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex sm12 xs12 style="flex: 0 0 31.6%; max-width: 31.6%;">
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" flat>
            <div class="mt-2 ml-4 font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Viral Posts
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Analyzed Highly Engaged Contents
            </div>

            <v-card class="mt-5" flat>
              <div
                ref="viralPostsScrollContainer"
                style="background-color: #fff; height: 390px; overflow-y: auto;"
              >
                <div v-for="(item, index) in paginatedViralPosts" :key="item.id || index">
                  <v-list class="py-0" dense>
                    <v-list-item
                      class="px-0"
                      :href="item.socmed === 'youtube' ? item.url : null"
                      :target="item.socmed === 'youtube' ? '_blank' : null"
                    >
                      <v-list-item-avatar
                        v-if="item.user_profile_image_url"
                        class="mt-n2"
                        style="transform: translateY(-8px);"
                        size="38"
                      >
                        <v-img :src="item.user_profile_image_url"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-avatar
                        v-else
                        class="mt-n2"
                        style="transform: translateY(-8px);"
                        size="38"
                        color="grey lighten-2"
                      >
                        <v-icon v-if="item.socmed === 'youtube'" color="red">
                          mdi-youtube
                        </v-icon>
                        <v-icon v-else>mdi-account</v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content class="py-0" style="margin-left: -4px;">
                        <v-list-item-title class="font-weight-bold d-flex align-center" style="font-size: 14px;">
                          <span>
                            {{ item.user_name }}
                            <v-icon v-if="item.verified" small color="blue">
                              mdi-check-decagram
                            </v-icon>
                            <v-icon v-if="item.socmed === 'youtube'" small color="red" class="ml-1">
                              mdi-youtube
                            </v-icon>
                            <v-icon v-else small class="ml-1">
                              fa-brands fa-x-twitter
                            </v-icon>
                          </span>

                          <span class="font-weight-regular ml-1" style="color: #657786; font-size: 13px;">
                            @{{ item.user_screen_name }} · {{ formatCreatedAt(item.created_at) }}
                          </span>
                        </v-list-item-title>

                        <p class="mt-1 mb-5" style="font-size: 14px;">
                          {{ item.text }}
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-row class="mx-0 ml-11 mb-2 align-center" style="font-size: 14px; color: #5B7083;">
                    <v-col cols="3" class="pa-1 d-flex align-center">
                      <v-icon small class="mr-1">
                        mdi-comment-outline
                      </v-icon>
                      {{ formatCount(item.reply_count) }}
                    </v-col>
                    <v-col cols="3" class="pa-1 d-flex align-center">
                      <v-icon v-if="item.socmed === 'youtube'" small class="mr-1">
                        mdi-youtube-subscription
                      </v-icon>
                      <v-icon v-else small class="mr-1">
                        fa-light fa-retweet
                      </v-icon>
                      {{ formatCount(item.share_count) }}
                    </v-col>
                    <v-col cols="3" class="pa-1 d-flex align-center">
                      <v-icon small class="mr-1">
                        mdi-heart-outline
                      </v-icon>
                      {{ formatCount(item.like_count) }}
                    </v-col>
                    <v-col cols="3" class="pa-1 d-flex align-center">
                      <v-icon small class="mr-1">
                        mdi-chart-bar
                      </v-icon>
                      {{ formatCount(item.view_count) }}
                    </v-col>
                  </v-row>

                  <v-divider
                    v-if="index < paginatedViralPosts.length - 1"
                    class="my-2"
                    style="border-width: 1px;"
                  ></v-divider>
                </div>
              </div>

              <v-pagination
                v-if="pageLengthViralPosts > 1"
                class="mt-2 my-2"
                v-model="pageViralPosts"
                :length="pageLengthViralPosts"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="handlePageChangeViralPosts"
              ></v-pagination>
            </v-card>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex sm12 xs12 style="flex: 0 0 36.6%; max-width: 36.6%;">
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" style="position: relative;" height="510px" flat>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon style="position: absolute; top: 10px; right: 10px;" color="#2B4A6F">
                  <v-icon>mdi-filter-variant</v-icon>
                </v-btn>

                <v-btn
                  style="position: absolute; top: 50px; right: 10px;"
                  color="#2B4A6F"
                  icon
                  @click="dialogHashtagsExpanded = true"
                >
                  <span
                    style="
                      font-size: 22px;
                      font-style: normal;
                      line-height: 1;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      transform: rotate(0deg);
                    "
                  >
                    ⛶
                  </span>
                </v-btn>
              </template>

              <v-list style="min-width: 240px;" dense>
                <v-list-item>
                  <v-checkbox
                    v-model="selectedHashtags"
                    label="Simultaneous CI (95%)"
                    value="Simultaneous CI (95%)"
                    color="#2B4A6F"
                    dense
                    hide-details
                    @change="updateHashtagChartData(currentHashtagIndex)"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="selectedHashtags"
                    label="Prediksi 7 Hari Ke Depan"
                    value="Prediksi 7 Hari Ke Depan"
                    color="#2B4A6F"
                    dense
                    hide-details
                    @change="updateHashtagChartData(currentHashtagIndex)"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="selectedHashtags"
                    label="Future CI"
                    value="Future CI"
                    color="#2B4A6F"
                    dense
                    hide-details
                    @change="updateHashtagChartData(currentHashtagIndex)"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="selectedHashtags"
                    label="Change Point"
                    value="Change Point"
                    color="#2B4A6F"
                    dense
                    hide-details
                    @change="updateHashtagChartData(currentHashtagIndex)"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="selectedHashtags"
                    label="Mean per Segment"
                    value="Mean per Segment"
                    color="#2B4A6F"
                    dense
                    hide-details
                    @change="updateHashtagChartData(currentHashtagIndex)"
                  ></v-checkbox>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="mt-1 ml-4 font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Hashtags
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Trends of Influencing Hashtags
            </div>

            <v-card-subtitle style="margin-top: 8px; font-size: 18px; font-weight: 600; color: #2c4c73; font-family: Roboto;">
              #{{ valueHashtags }}
            </v-card-subtitle>

            <div style="position: relative; display: flex; align-items: center; justify-content: center;">
              <v-icon
                class="chevron-left"
                :style="{
                  position: 'absolute',
                  left: '-15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: (currentHashtagIndex == 0 || allHashtags.length <= 1) ? 'default' : 'pointer',
                  color: (currentHashtagIndex == 0 || allHashtags.length <= 1) ? '#ccc' : '#2B4A6F'
                }"
                size="36"
                @click="currentHashtagIndex > 0 && handleLeftClickHashtags()"
              >
                mdi-chevron-left
              </v-icon>

              <div class="hashtags-chart-wrapper">
                <apexchart
                  ref="hashtagChart"
                  :options="optionsHashtags"
                  :series="seriesHashtags"
                  height="350"
                ></apexchart>
              </div>

              <v-icon
                class="chevron-right"
                :style="{
                  position: 'absolute',
                  right: '-15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: (currentHashtagIndex >= allHashtags.length - 1 || allHashtags.length <= 1) ? 'default' : 'pointer',
                  color: (currentHashtagIndex >= allHashtags.length - 1 || allHashtags.length <= 1) ? '#ccc' : '#2B4A6F'
                }"
                size="36"
                @click="currentHashtagIndex < allHashtags.length - 1 && handleRightClickHashtags()"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card>
        </v-card>
      </v-flex>

      <v-flex sm12 xs12 style="flex: 0 0 31.6%; max-width: 31.6%;">
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" height="510px" flat>
            <div class="ml-4 font-weight-medium font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Trending Phrases
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Common Phrases in Viral Posts
            </div>

            <v-card-subtitle style="margin-top: 8px; font-size: 18px; font-weight: 600; color: #2c4c73; font-family: Roboto;">
              {{ selectedTrendingPhrases }}
            </v-card-subtitle>

            <div style="position: relative; display: flex; align-items: center; justify-content: center;">
              <v-icon
                class="chevron-left"
                :style="{
                  position: 'absolute',
                  left: '-15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: currentTrendingPhrasesIndex == 0 ? 'default' : 'pointer',
                  color: currentTrendingPhrasesIndex == 0 ? '#ccc' : '#2B4A6F'
                }"
                size="36"
                @click="handleLeftClickTrendingPhrases()"
              >
                mdi-chevron-left
              </v-icon>

              <v-flex lg12>
                <wordcloud
                  class="wordcloud-class"
                  :data="wordsTrendingPhrases"
                  nameKey="name"
                  valueKey="value"
                  font="Roboto"
                  spiral="rectangular"
                  :fontSize="fontSizeTrendingPhrases"
                  :color="colorsTrendingPhrases"
                  :rotate="rotateTrendingPhrases"
                  :wordPadding="4"
                  :showTooltip="true"
                ></wordcloud>
              </v-flex>

              <v-icon
                class="chevron-right"
                :style="{
                  position: 'absolute',
                  right: '-15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: currentTrendingPhrasesIndex == 1 ? 'default' : 'pointer',
                  color: currentTrendingPhrasesIndex == 1 ? '#ccc' : '#2B4A6F'
                }"
                size="36"
                @click="handleRightClickTrendingPhrases()"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card>
        </v-card>
      </v-flex>

      <!-- <v-flex v-if="!devOrigins.includes(currentOrigin)" lg5 sm12 xs12>
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" height="500px" flat>
            <div class="mt-2 ml-4 font-weight-medium font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Mentions
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Contributed Influencers
            </div>

            <div class="mt-4 bubble-container">
              <div
                v-for="(entity, index) in mentions"
                :key="index"
                class="bubble d-flex align-center justify-center"
                :style="{
                  width: entity.size + 'px',
                  height: entity.size + 'px',
                  top: entity.top + 'px',
                  left: entity.left + 'px',
                  position: 'absolute',
                  borderRadius: '50%',
                  backgroundColor: backgroundColorMentions[index % backgroundColorMentions.length],
                  overflow: 'hidden',
                  textAlign: 'center',
                  cursor: 'default'
                }"
                @mouseenter="showTooltipMentions(entity, $event)"
                @mousemove="moveTooltipMentions($event)"
                @mouseleave="hideTooltipMentions"
              >
                <div
                  class="inner-bubble d-flex align-center justify-center"
                  :style="{
                    width: (entity.size * 0.45) + 'px',
                    height: (entity.size * 0.45) + 'px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    overflow: 'hidden'
                  }"
                >
                  <img
                    :src="entity.image ? entity.image : 'defaultLogo.png'"
                    :alt="entity.name"
                    class="bubble-image"
                    style="width: 100%; height: 100%; object-fit: cover;"
                  />
                </div>
              </div>

              <div
                v-if="tooltipMentions.visible"
                :style="{ top: tooltipMentions.top + 'px', left: tooltipMentions.left + 'px' }"
                class="tooltip-mentions"
              >
                <b style="font-size: 16px;">
                  {{ tooltipMentions.data.name }}
                </b>
                <br />
                {{ tooltipMentions.data.totalPost }} total post<br />
                {{ formatCount(tooltipMentions.data.follower) }} follower<br />
              </div>
            </div>
          </v-card>
        </v-card>
      </v-flex> -->

      <v-flex lg12 sm12 xs12>
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-card class="mx-4 mb-6 rounded-lg pa-4" style="position: relative; height: 500px;" flat>
            <div class="ml-4 font-weight-medium font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
              Propagation Map
            </div>

            <div
              class="grey--text text-caption"
              style="position: absolute; top: 22px; right: 35px; font-size: 14px !important;"
            >
              This analysis has been calculated on {{ lastCalculatedOn }}
            </div>

            <div class="mt-4 semantic-container">
              <div class="propagation-map-search-controls">
                <div class="search-node-wrapper">
                  <v-text-field
                    v-model="searchNodeUsername"
                    label="Search Node"
                    prepend-inner-icon="mdi-magnify"
                    style="width: 160px;"
                    color="black"
                    outlined
                    dense
                    hide-details
                    @input="searchNodesByUsername"
                  />
                </div>

                <div class="cluster-switch-wrapper">
                  <div class="cluster-switch-btn" @click="previousNodeByCluster">
                    ‹
                  </div>
                  <span class="cluster-switch-label">
                    {{ selectedFilterCluster == "all"
                      ? "All Clusters"
                      : clustersPropagationMap.find(c => c.name == selectedFilterCluster)?.label || selectedFilterCluster
                    }}
                  </span>
                  <div class="cluster-switch-btn" @click="nextNodeByCluster">
                    ›
                  </div>
                </div>
              </div>

              <div class="propagation-map-controls">
                <div class="map-control-btn" @click="zoomInPropagationMap">
                  +
                </div>
                <div class="map-control-btn" @click="zoomOutPropagationMap">
                  −
                </div>
                <div class="map-control-btn fullscreen-btn" @click="openFullScreen">
                  ⛶
                </div>
              </div>

              <div
                ref="containerRef"
                class="canvas-container"
                :style="{ cursor: cursorStylePropagationMap }"
              />

              <div v-if="isLoadingAdvancedSemantic" class="semantic-loading-overlay">
                <div class="semantic-loading-content">
                  <div class="semantic-loading-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                  </div>
                  <div class="semantic-loading-title">
                    Recalculating Semantic Grouping
                  </div>
                  <div class="semantic-loading-subtitle">
                    Applying new parameters — Minimal Distance
                    <strong>{{ semanticMinimalDistance || 1 }}</strong>
                    &amp; Spreadness
                    <strong>{{ semanticSpreadness || 1.5 }}</strong>
                  </div>
                  <div class="semantic-loading-steps">
                    <span :class="{ active: loadingStep >= 1 }">
                      ● Fetching nodes
                    </span>
                    <span :class="{ active: loadingStep >= 2 }">
                      ● Rebuilding clusters
                    </span>
                    <span :class="{ active: loadingStep >= 3 }">
                      ● Rendering map
                    </span>
                  </div>
                </div>
              </div>

              <div
                v-if="hoveredSemanticNodes"
                class="tooltip-propagation-map"
                :style="{
                  left: mousePosition.x + 15 + 'px',
                  top: mousePosition.y - 80 + 'px'
                }"
              >
                <div class="tooltip-header">
                  <img
                    v-if="hoveredSemanticNodes.image"
                    :src="hoveredSemanticNodes.image"
                    class="tooltip-avatar"
                    alt="profile"
                  />
                  <div class="tooltip-content">
                    <div class="tooltip-title-propagation-map">
                      {{ hoveredSemanticNodes.userName }}
                    </div>
                    <div class="tooltip-coordinate-propagation-map">
                      <strong>{{ formatCount(hoveredSemanticNodes.engagement) }}</strong> engagements,
                      <strong>{{ formatCount(hoveredSemanticNodes.totalPost) }}</strong> contents
                    </div>
                  </div>
                </div>
                <div class="tooltip-body">
                  <div class="viral-posts-container">
                    <div
                      v-for="(item, index) in hoveredSemanticNodes.viralPosts"
                      :key="item.id"
                      class="viral-post-item"
                    >
                      <div class="post-header">
                        <img
                          :src="item.user_profile_image_url"
                          class="post-avatar"
                          alt="avatar"
                        />
                        <div class="post-info">
                          <div class="post-user">
                            <span class="user-name">
                              {{ item.user_name }}
                            </span>
                            <v-icon
                              v-if="item.verified__b"
                              x-small
                              color="blue"
                              class="ml-1"
                            >
                              mdi-check-decagram
                            </v-icon>
                            <span class="user-meta">
                              @{{ item.user_screen_name }} · {{ formatCreatedAt(item.created_at) }}
                            </span>
                          </div>
                          <p class="post-text">
                            {{ item.text }}
                          </p>
                        </div>
                      </div>

                      <div class="post-statistics">
                        <div class="post-statistics-item">
                          <v-icon x-small class="post-statistics-icon">
                            mdi-comment-outline
                          </v-icon>
                          <span>
                            {{ formatCount(item.reply_count__s) }}
                          </span>
                        </div>
                        <div class="post-statistics-item">
                          <v-icon x-small class="post-statistics-icon">
                            mdi-repeat
                          </v-icon>
                          <span>
                            {{ formatCount(item.retweet_count) }}
                          </span>
                        </div>
                        <div class="post-statistics-item">
                          <v-icon x-small class="post-statistics-icon">
                            mdi-heart-outline
                          </v-icon>
                          <span>
                            {{ formatCount(item.like__s) }}
                          </span>
                        </div>
                        <div class="post-statistics-item">
                          <v-icon x-small class="post-statistics-icon">
                            mdi-chart-bar
                          </v-icon>
                          <span>
                            {{ formatCount(item.view_count) }}
                          </span>
                        </div>
                      </div>

                      <div
                        v-if="index < hoveredSemanticNodes.viralPosts.length - 1"
                        class="post-divider"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="mt-4 mr-4"
              style="position: absolute; right: 16px; top: 60px; width: 30%; transition: height 0.3s ease;"
              :style="{ height: activePanelPropagationMap !== undefined ? 'calc(100% - 76px)' : 'auto' }"
            >
              <v-card
                style="overflow-y: auto; transition: height 0.3s ease;"
                :style="{
                  height:
                    activePanelPropagationMap == 0
                      ? '100%'
                      : activePanelPropagationMap == 1
                      ? '75%'
                      : 'auto'
                }"
                outlined
              >
                <v-expansion-panels v-model="activePanelPropagationMap">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h3>Community</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p class="text-body-2">
                        Click a community to show/hide related nodes from the map.
                      </p>

                      <v-row v-if="clustersPropagationMap.length != 0" justify="center">
                        <v-col cols="auto" class="pr-2">
                          <v-btn
                            color="#000"
                            style="width: 120px;"
                            height="40"
                            dense
                            dark
                            rounded
                            :outlined="!isColorClusterPropagationMap"
                            @click="loadColorClusterNode"
                          >
                            Cluster
                          </v-btn>
                        </v-col>
                        <v-col cols="auto" class="pl-2">
                          <v-btn
                            color="#000"
                            style="width: 120px;"
                            height="40"
                            dense
                            dark
                            rounded
                            :outlined="isColorClusterPropagationMap"
                            @click="loadColorSentimentNode"
                          >
                            Sentiment
                          </v-btn>
                        </v-col>
                      </v-row>

                      <div v-if="clustersPropagationMap.length != 0" class="d-flex justify-space-between ml-4">
                        <v-row
                          :style="isCheckAllPropagationMap ? 'margin-left: 65px' : 'margin-left: 25px'"
                          class="d-flex justify-end"
                          align="center"
                        >
                          <v-col cols="2">
                            <v-checkbox
                              v-model="isCheckAllPropagationMap"
                              color="#000"
                              @click="clickCheckAllPropagationMap"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="5">
                            <span v-if="isCheckAllPropagationMap == true">
                              Check All
                            </span>
                            <span v-if="isCheckAllPropagationMap == false">
                              Uncheck All
                            </span>
                          </v-col>
                        </v-row>
                      </div>

                      <v-list dense>
                        <v-list-item v-for="(cluster, index) in clustersPropagationMap" :key="index">
                          <v-list-item-action>
                            <v-checkbox
                              v-model="cluster.checked"
                              color="#000"
                              @click="toggleClusterPropagationMap(cluster.name)"
                            ></v-checkbox>
                          </v-list-item-action>
                          <v-list-item-content>
                            <div style="display: flex; align-items: center; gap: 8px;">
                              <v-avatar :color="cluster.color" size="20"></v-avatar>
                              <v-list-item-title>
                                {{ cluster.label }}
                              </v-list-item-title>
                              <v-list-item-title style="margin-left: auto; text-align: right;">
                                {{ cluster.percentage }} %
                              </v-list-item-title>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h3>Advanced</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list dense>
                        <v-list-item v-for="(item, index) in itemsAdvancedPropagationMap" :key="index">
                          <v-row align="center">
                            <v-col style="max-width: 29%; flex: 0 0 29%;">
                              <template v-if="index == 0">
                                <v-text-field
                                  v-model="semanticMinimalDistance"
                                  type="number"
                                  placeholder="1"
                                  step="0.1"
                                  min="0"
                                  outlined
                                  dense
                                  hide-details
                                />
                              </template>

                              <template v-if="index == 1">
                                <v-text-field
                                  v-model="semanticSpreadness"
                                  class="mt-4"
                                  type="number"
                                  placeholder="1.5"
                                  step="0.1"
                                  min="0"
                                  outlined
                                  dense
                                  hide-details
                                />
                              </template>
                            </v-col>

                             <v-col style="max-width: 71%; flex: 0 0 71%;">
                              <v-list-item-content>
                                <v-list-item-title :class="{ 'mt-3': index == 1 }">
                                  {{ item }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-col>

                            <p v-if="index == 0" style="font-size: 11px; margin-left: 12px;">
                              Recommended: 1 for minimal distance
                            </p>
                            <p v-if="index == 1" style="font-size: 11px; margin-left: 12px;">
                              Recommended: 1.5 for spreadness
                            </p>
                          </v-row>
                        </v-list-item>
                      </v-list>

                      <p
                        v-if="advancedSemanticError"
                        style="color: red; font-size: 12px; margin-top: 4px; margin-left: 15px; text-align: left;"
                      >
                        {{ advancedSemanticError }}
                      </p>

                      <v-row justify="end">
                        <v-btn
                          class="mt-5 mb-5 white--text"
                          color="#000000"
                          @click="applyAdvancedSemantic"
                        >
                          Apply
                        </v-btn>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </div>
          </v-card>
        </v-card>
      </v-flex>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              Loading content, please wait
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogSearchContext" height="500" width="350">
        <v-card class="pa-5" color="var(--color-theme-secondary)" rounded="lg" dark>
          <v-btn class="btn-close-dialog-search-context" icon @click="dialogSearchContext = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text
            class="text-center"
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;"
          >
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ searchContextTopic }}</strong> <br>
              From: <strong>{{ searchContextStartDate }}</strong> to <strong>{{ searchContextEndDate }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="dialogConfirmReset = false"
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPageInsight" attach="#floating-dialog-anchor" width="340" scrollable hide-overlay>
        <v-card style="position: fixed; bottom: 120px; right: 30px; border-radius: 12px; height: 460px; width: 60%" elevation="8">
          <v-card-title class="white--text" :style="{ backgroundColor: 'var(--color-theme)' }">
            <SparklesIcon class="w-4 h-4" style="color: white;" />
            <span class="ml-2 font-weight-bold">
              Insights AI Assistant
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="regenerateInsight">
              <v-icon
                color="white"
                :class="{ 'rotate-animation': isRotatingRegenerateInsight }"
                style="transform: rotate(90deg);"
              >
                mdi-sync
              </v-icon>
            </v-btn>
            <v-btn icon @click="dialogPageInsight = false">
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="mt-5" style="max-height: 345px; overflow-y: auto;">
            <div v-if="loadingResponseDescribeDashboard && listResponseDescribeDashboard.length == 0" class="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </div>

            <div
              v-if="
                !loadingResponseDescribeDashboard &&
                listResponseDescribeDashboard.length == 1 &&
                listResponseDescribeDashboard[0] == 'The server is busy. Please try again later.'
              "
            >
              <div class="d-flex justify-end">
                <div
                  class="response-text-describe-viral rounded-lg"
                  style="width: 100%"
                  v-html="formatTextDescribeDashboard(listResponseDescribeDashboard[0])"
                ></div>
              </div>
            </div>

            <div v-else v-for="(item, index) in listResponseDescribeDashboard" :key="index" class="mb-2">
              <template v-if="currentLoadingIndex == index">
                <div class="loading-dots">
                  <span>.</span><span>.</span><span>.</span>
                </div>
              </template>
              <template v-else-if="currentLoadingIndex > index">
                <div class="d-flex justify-end">
                  <div
                    class="response-text-describe-viral rounded-lg"
                    style="width: 100%"
                    v-html="formatTextDescribeDashboard(item)"
                  ></div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div id="floating-dialog-anchor"></div>

      <div
        v-if="dialogFullScreen"
        ref="fullScreenOverlay"
        class="propagation-fullscreen-overlay"
      >
        <div class="semantic-container-full-screen">
          <div class="propagation-map-search-controls-fullscreen">
            <div class="search-node-wrapper">
              <v-text-field
                v-model="searchNodeUsername"
                label="Search Node"
                prepend-inner-icon="mdi-magnify"
                style="width: 160px;"
                color="black"
                outlined
                dense
                hide-details
                @input="searchNodesByUsername"
              />
            </div>

            <div class="cluster-switch-wrapper">
              <div class="cluster-switch-btn" @click="previousNodeByCluster">
                ‹
              </div>
              <span class="cluster-switch-label">
                {{ selectedFilterCluster == "all"
                  ? "All Clusters"
                  : clustersPropagationMap.find(c => c.name == selectedFilterCluster)?.label || selectedFilterCluster
                }}
              </span>
              <div class="cluster-switch-btn" @click="nextNodeByCluster">
                ›
              </div>
            </div>
          </div>

          <div class="propagation-map-controls-full-screen">
            <div class="map-control-btn-full-screen" @click="zoomInFullScreen">
              +
            </div>
            <div class="map-control-btn-full-screen" @click="zoomOutFullScreen">
              −
            </div>
            <div class="map-control-btn-full-screen fullscreen-btn" style="font-size: 16px;" @click="closeFullScreen">
              ✕
            </div>
          </div>

          <div
            ref="containerRefFullScreen"
            class="canvas-container-full-screen"
            :style="{ cursor: cursorStylePropagationMapFullScreen }"
          />

          <div v-if="isLoadingAdvancedSemantic" class="semantic-loading-overlay">
            <div class="semantic-loading-content">
              <div class="semantic-loading-spinner">
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
              </div>
              <div class="semantic-loading-title">
                Recalculating Semantic Grouping
              </div>
              <div class="semantic-loading-subtitle">
                Applying new parameters — Minimal Distance
                <strong>{{ semanticMinimalDistance || 1 }}</strong>
                &amp; Spreadness
                <strong>{{ semanticSpreadness || 1.5 }}</strong>
              </div>
              <div class="semantic-loading-steps">
                <span :class="{ active: loadingStep >= 1 }">
                  ● Fetching nodes
                </span>
                <span :class="{ active: loadingStep >= 2 }">
                  ● Rebuilding clusters
                </span>
                <span :class="{ active: loadingStep >= 3 }">
                  ● Rendering map
                </span>
              </div>
            </div>
          </div>

          <div
            v-if="hoveredSemanticNodesFullScreen"
            class="tooltip-propagation-map-full-screen"
            :style="{
              left: mousePositionFullScreen.x + 15 + 'px',
              top: mousePositionFullScreen.y - 80 + 'px'
            }"
          >
            <div class="tooltip-header">
              <img
                v-if="hoveredSemanticNodesFullScreen.image"
                :src="hoveredSemanticNodesFullScreen.image"
                class="tooltip-avatar"
                alt="profile"
              />
              <div class="tooltip-content">
                <div class="tooltip-title-propagation-map-full-screen">
                  {{ hoveredSemanticNodesFullScreen.userName }}
                </div>
                <div class="tooltip-coordinate-propagation-map-full-screen">
                  <strong>{{ formatCount(hoveredSemanticNodesFullScreen.engagement) }}</strong> engagements,
                  <strong>{{ formatCount(hoveredSemanticNodesFullScreen.totalPost) }}</strong> contents
                </div>
              </div>
            </div>

            <div class="tooltip-body">
              <div class="viral-posts-container">
                <div
                  v-for="(item, index) in hoveredSemanticNodesFullScreen.viralPosts"
                  :key="item.id"
                  class="viral-post-item"
                >
                  <div class="post-header">
                    <img
                      :src="item.user_profile_image_url"
                      class="post-avatar"
                      alt="avatar"
                    />
                    <div class="post-info">
                      <div class="post-user">
                        <span class="user-name">
                          {{ item.user_name }}
                        </span>
                        <v-icon
                          v-if="item.verified__b"
                          x-small
                          color="blue"
                          class="ml-1"
                        >
                          mdi-check-decagram
                        </v-icon>
                        <span class="user-meta">
                          @{{ item.user_screen_name }} · {{ formatCreatedAt(item.created_at) }}
                        </span>
                      </div>
                      <p class="post-text">
                        {{ item.text }}
                      </p>
                    </div>
                  </div>

                  <div class="post-statistics">
                    <div class="post-statistics-item">
                      <v-icon x-small class="post-statistics-icon">
                        mdi-comment-outline
                      </v-icon>
                      <span>
                        {{ formatCount(item.reply_count__s) }}
                      </span>
                    </div>
                    <div class="post-statistics-item">
                      <v-icon x-small class="post-statistics-icon">
                        mdi-repeat
                      </v-icon>
                      <span>
                        {{ formatCount(item.retweet_count) }}
                      </span>
                    </div>
                    <div class="post-statistics-item">
                      <v-icon x-small class="post-statistics-icon">
                        mdi-heart-outline
                      </v-icon>
                      <span>
                        {{ formatCount(item.like__s) }}
                      </span>
                    </div>
                    <div class="post-statistics-item">
                      <v-icon x-small class="post-statistics-icon">
                        mdi-chart-bar
                      </v-icon>
                      <span>
                        {{ formatCount(item.view_count) }}
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="index < hoveredSemanticNodesFullScreen.viralPosts.length - 1"
                    class="post-divider"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style="position: absolute; right: 16px; top: 60px; width: 30%; transition: height 0.3s ease;"
          :style="{ height: activePanelPropagationMapFullScreen !== undefined ? 'calc(100% - 76px)' : 'auto' }"
        >
          <v-card
            style="overflow-y: auto; transition: height 0.3s ease;"
            :style="{
              height:
                activePanelPropagationMapFullScreen == 0
                  ? '90%'
                  : activePanelPropagationMapFullScreen == 1
                  ? '46%'
                  : 'auto'
            }"
            outlined
          >
            <v-expansion-panels v-model="activePanelPropagationMapFullScreen">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3>Community</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="text-body-2">
                    Click a community to show/hide related nodes from the map.
                  </p>

                  <v-row v-if="clustersPropagationMap.length != 0" justify="center">
                    <v-col cols="auto" class="pr-2">
                      <v-btn
                        color="#000"
                        style="width: 120px;"
                        height="40"
                        dense
                        dark
                        rounded
                        :outlined="!isColorClusterPropagationMapFullScreen"
                        @click="loadColorClusterNodeFullScreen"
                      >
                        Cluster
                      </v-btn>
                    </v-col>
                    <v-col cols="auto" class="pl-2">
                      <v-btn
                        color="#000"
                        style="width: 120px;"
                        height="40"
                        dense
                        dark
                        rounded
                        :outlined="isColorClusterPropagationMapFullScreen"
                        @click="loadColorSentimentNodeFullScreen"
                      >
                        Sentiment
                      </v-btn>
                    </v-col>
                  </v-row>

                  <div v-if="clustersPropagationMap.length != 0" class="d-flex justify-space-between ml-4">
                    <v-row
                      :style="isCheckAllPropagationMapFullScreen ? 'margin-left: 65px' : 'margin-left: 25px'"
                      class="d-flex justify-end"
                      align="center"
                    >
                      <v-col cols="2">
                        <v-checkbox
                          v-model="isCheckAllPropagationMapFullScreen"
                          color="#000"
                          @click="clickCheckAllPropagationMapFullScreen"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="5">
                        <span v-if="isCheckAllPropagationMapFullScreen == true">
                          Check All
                        </span>
                        <span v-if="isCheckAllPropagationMapFullScreen == false">
                          Uncheck All
                        </span>
                      </v-col>
                    </v-row>
                  </div>

                  <v-list dense>
                    <v-list-item v-for="(cluster, index) in clustersPropagationMapFullScreen" :key="index">
                      <v-list-item-action>
                        <v-checkbox
                          v-model="cluster.checked"
                          color="#000"
                          @click="toggleClusterPropagationMapFullScreen(cluster.name)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <v-avatar :color="cluster.color" size="20"></v-avatar>
                          <v-list-item-title>
                            {{ cluster.label }}
                          </v-list-item-title>
                          <v-list-item-title style="margin-left: auto; text-align: right;">
                            {{ cluster.percentage }} %
                          </v-list-item-title>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3>Advanced</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-list dense>
                    <v-list-item v-for="(item, index) in itemsAdvancedPropagationMap" :key="index">
                      <v-row align="center">
                        <v-col cols="3">
                          <template v-if="index == 0">
                            <v-text-field
                              v-model="semanticMinimalDistance"
                              type="number"
                              placeholder="1"
                              step="0.1"
                              min="0"
                              outlined
                              dense
                              hide-details
                            />
                          </template>

                          <template v-if="index == 1">
                            <v-text-field
                              v-model="semanticSpreadness"
                              class="mt-4"
                              type="number"
                              placeholder="1.5"
                              step="0.1"
                              min="0"
                              outlined
                              dense
                              hide-details
                            />
                          </template>
                        </v-col>

                         <v-col cols="5">
                          <v-list-item-content>
                            <v-list-item-title :class="{ 'mt-3': index == 1 }">
                              {{ item }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-col>

                        <p v-if="index == 0" style="font-size: 11px; margin-left: 12px;">
                          Recommended: 1 for minimal distance
                        </p>
                        <p v-if="index == 1" style="font-size: 11px; margin-left: 12px;">
                          Recommended: 1.5 for spreadness
                        </p>
                      </v-row>
                    </v-list-item>
                  </v-list>

                  <p
                    v-if="advancedSemanticError"
                    style="color: red; font-size: 12px; margin-top: 4px; margin-left: 15px; text-align: left;"
                  >
                    {{ advancedSemanticError }}
                  </p>

                  <v-row justify="end">
                    <v-btn
                      class="mt-5 mb-5 white--text"
                      color="#000000"
                      @click="applyAdvancedSemantic"
                    >
                      Apply
                    </v-btn>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </div>
      </div>

      <v-dialog v-model="dialogHashtagsExpanded" width="800px" @keydown.esc="dialogHashtagsExpanded = false">
        <v-card
          class="pa-4"
          style="width: 800px; height: 90vh; display: flex; flex-direction: column;"
          rounded="xl"
          elevation="10"
        >
          <div class="d-flex justify-space-between align-center mb-2">
            <div class="d-flex flex-column ml-4">
              <div class="mt-1 font-weight-bold" style="font-size: 24px; color:#2B4A6F;">
                Hashtags
              </div>
              <div class="grey--text" style="font-size: 15px;">
                Trends of Influencing Hashtags
              </div>
              <div style="margin-top: 10px; font-size: 18px; font-weight: 600; color: #2c4c73; font-family: Roboto;">
                #{{ valueHashtags }}
              </div>
            </div>

            <div class="d-flex align-center">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="#2B4A6F">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>

                <v-list style="min-width: 240px;" dense>
                  <v-list-item>
                    <v-checkbox
                      v-model="selectedHashtags"
                      label="Simultaneous CI (95%)"
                      value="Simultaneous CI (95%)"
                      color="#2B4A6F"
                      dense
                      hide-details
                      @change="updateHashtagChartData(currentHashtagIndex)"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="selectedHashtags"
                      label="Prediksi 7 Hari Ke Depan"
                      value="Prediksi 7 Hari Ke Depan"
                      color="#2B4A6F"
                      dense
                      hide-details
                      @change="updateHashtagChartData(currentHashtagIndex)"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="selectedHashtags"
                      label="Future CI"
                      value="Future CI"
                      color="#2B4A6F"
                      dense
                      hide-details
                      @change="updateHashtagChartData(currentHashtagIndex)"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="selectedHashtags"
                      label="Change Point"
                      value="Change Point"
                      color="#2B4A6F"
                      dense
                      hide-details
                      @change="updateHashtagChartData(currentHashtagIndex)"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="selectedHashtags"
                      label="Mean per Segment"
                      value="Mean per Segment"
                      color="#2B4A6F"
                      dense
                      hide-details
                      @change="updateHashtagChartData(currentHashtagIndex)"
                    ></v-checkbox>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn icon @click="dialogHashtagsExpanded = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <div style="flex: 1; display: flex; justify-content: center; position: relative; min-height: 0; padding: 0 40px;">
            <v-icon
              :style="{
                position: 'absolute',
                top: '50%',
                left: '0px',
                cursor: (currentHashtagIndex == 0 || allHashtags.length <= 1) ? 'default' : 'pointer',
                color: (currentHashtagIndex == 0 || allHashtags.length <= 1) ? '#ccc' : '#2B4A6F'
              }"
              size="36"
              @click="currentHashtagIndex > 0 && handleLeftClickHashtags()"
            >
              mdi-chevron-left
            </v-icon>

            <apexchart
              :options="optionsHashtagsExpanded"
              :series="seriesHashtagsExpanded"
              height="100%"
              width="100%"
              style="flex: 1;"
            ></apexchart>

            <v-icon
              :style="{
                position: 'absolute',
                top: '50%',
                right: '0px',
                cursor: (currentHashtagIndex >= allHashtags.length - 1 || allHashtags.length <= 1) ? 'default' : 'pointer',
                color: (currentHashtagIndex >= allHashtags.length - 1 || allHashtags.length <= 1) ? '#ccc' : '#2B4A6F'
              }"
              size="36"
              @click="currentHashtagIndex < allHashtags.length - 1 && handleRightClickHashtags()"
            >
              mdi-chevron-right
            </v-icon>
          </div>
        </v-card>
      </v-dialog>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import wordcloud from 'vue-wordcloud';
import Notification from '@/components/Notification';
import { decryptionData, generateFilterDate, processTopicKeywords, trackEvent } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
import { SparklesIcon } from "@vue-hero-icons/solid";
import * as THREE from 'three';

export default {
  components: {
    wordcloud,
    Notification: Notification,
    SparklesIcon
  },
  data: function() {
    return {
      persenPublicSentimentNegative: 0,
      persenPublicSentimentNeutral: 0,
      persenPublicSentimentPositive: 0,
      optionsPublicSentiment: {
        chart: {
          height: 180,
          type: 'area',
          stacked: true,
          toolbar: { show: false },
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        dataLabels: { enabled: false },
        grid: {
          show: false,
          padding: { left: 0, right: 0 }
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            style: {
              fontSize: '11px'
            }
          }
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 2,
          labels: {
            formatter: val => val.toFixed(0) + '%'
          }
        },
        colors: ['#FFB5AC', '#EAF0F5', '#BFECFE'],
        fill: {
          type: 'solid',
          colors: ['#FFB5AC', '#EAF0F5', '#BFECFE'],
          opacity: 1
        },
        legend: { show: false },
        tooltip: {
          x: {
            show: false,
            formatter: undefined
          },
          y: {
            formatter: (val) => `${val}%`
          },
          marker: {
            show: true
          },
          shared: true
        }
      },
      seriesPublicSentiment: [
        {
          name: "Negative",
          data: []
        },
        {
          name: "Neutral",
          data: []
        },
        {
          name: "Positive",
          data: []
        }
      ],
      listSourceCollection: "",
      cardColorsSourceCollection: ['#3BB3D3', '#4D9DC9', '#7EC9F5', '#405A78', '#1877F2'],
      sourceCollectionTotals: {
        twitter: 0,
        youtube: 0,
        tiktok: 0,
        instagram: 0,
        facebook: 0,
      },
      optionsSourceBreakdown: {
        colors: ['#EAF0F5', '#BFECFE', '#FFB5AC'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        labels: ["User Biasa", "Content Creator", "Buzzer"],
        legend: {
          show: true,
          position: 'right',
          fontSize: '18px',
          markers: {
            offsetX: -10,
          },
        },
      },
      seriesSourceBreakdown: [0, 0, 0],
      listViralPosts: [],
      pageViralPosts: 1,
      perPageViralPosts: 100,
      valueHashtags: "",
      currentHashtagIndex: 0,
      allHashtags: [],
      selectedHashtags: [],
      optionsHashtags: {
        chart: {
          height: 350,
          type: 'line',
          toolbar: {
            show: false
          },
        },
        stroke: {
          curve: 'smooth',
          width: [0, 3, 2, 2],
          dashArray: [0, 0, 0, 0],
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: [5, 0, 0, 0],
          hover: {
            size: [7, 0, 0, 0]
          }
        },
        grid: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            show: true
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        },
        colors: ['#808080', '#2B4A6F', '#94ddf7', '#94ddf7'],
        tooltip: {
          x: {
            show: false
          },
        },
        legend: {
          show: false
        },
        fill: {
          type: ['solid', 'solid', 'gradient', 'solid'],
          colors: ['#808080', '#2B4A6F', '#94ddf7', '#FFFFFF'],
          opacity: [1, 1, 0.5, 1.0],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
          }
        },
      },
      seriesHashtags: [
        {
          name: "Data Asli",
          type: "scatter",
          data: []
        },
        {
          name: "GAM Prediction",
          type: "line",
          data: []
        }
      ],
      dialogHashtagsExpanded: false,
      optionsHashtagsExpanded: {
        chart: {
          height: 350,
          type: 'line',
          toolbar: {
            show: false
          },
        },
        stroke: {
          curve: 'smooth',
          width: [0, 3, 2, 2],
          dashArray: [0, 0, 0, 0],
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: [5, 0, 0, 0],
          hover: {
            size: [7, 0, 0, 0]
          }
        },
        grid: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            show: true
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        },
        colors: ['#808080', '#2B4A6F', '#94ddf7', '#94ddf7'],
        tooltip: {
          x: {
            show: false
          },
        },
        legend: {
          show: false
        },
        fill: {
          type: ['solid', 'solid', 'gradient', 'solid'],
          colors: ['#808080', '#2B4A6F', '#94ddf7', '#FFFFFF'],
          opacity: [1, 1, 0.5, 1.0],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100]
          }
        },
      },
      seriesHashtagsExpanded: [
        {
          name: "Data Asli",
          type: "scatter",
          data: []
        },
        {
          name: "GAM Prediction",
          type: "line",
          data: []
        }
      ],
      allWordsTrendingPhrases: "",
      wordsTrendingPhrases: [],
      rotateTrendingPhrases: { from: 0, to: 0 },
      fontSizeTrendingPhrases: [10, 30],
      colorsTrendingPhrases: ['#036593', '#3BB3D3', '#2B4A6F', '#E0544C'],
      selectedTrendingPhrases: "Common Phrases",
      currentTrendingPhrasesIndex: 0,
      mentions: "",
      backgroundColorMentions: ["#8FCDE2", "#C0E2C7", "#C97BA8", "#86CAAC", "#9370db", "#fc2e20", "lightblue", "#009CFF", "#ffa500", "purple"],
      tooltipMentions: {
        visible: false,
        top: 0,
        left: 0,
        data: {}
      },
      lastCalculatedOn: '-',
      searchNodeUsername: "",
      selectedFilterCluster: "all",
      currentNodeIndex: 0,
      filteredNodesByCluster: [],
      initialSemanticNodesPropagationMap: [],
      semanticNodesPropagationMap: [],
      clusterColorPropagationMap: [],
      scene: null,
      camera: null,
      renderer: null,
      group: null,
      tunnelGroup: null,
      dotTexture: null,
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      sharedRotation: null,
      cursorStylePropagationMap: 'default',
      isDragging: false,
      isDraggingNode: false,
      draggedSemanticNode: null,
      previousMouse: { x: 0, y: 0 },
      isOverNode: false,
      hoveredSemanticNodes: null,
      mousePosition: { x: 0, y: 0 },
      tooltipPosition: { x: 0, y: 0 },
      activePanelPropagationMap: undefined,
      isColorClusterPropagationMap: true,
      clustersPropagationMap: [],
      isCheckAllPropagationMap: true,
      itemsAdvancedPropagationMap: ["Minimal Distance", "Spreadness"],
      semanticMinimalDistance: "",
      semanticSpreadness: "",
      isLoadingAdvancedSemantic: false,
      advancedSemanticError: "",
      loadingStep: 0,
      dialogFullScreen: false,
      sceneFullScreen: null,
      cameraFullScreen: null,
      rendererFullScreen: null,
      groupFullScreen: null,
      raycasterFullScreen: new THREE.Raycaster(),
      mouseFullScreen: new THREE.Vector2(),
      cursorStylePropagationMapFullScreen: 'default',
      isDraggingFullScreen: false,
      isDraggingNodeFullScreen: false,
      draggedSemanticNodeFullScreen: null,
      previousMouseFullScreen: { x: 0, y: 0 },
      isOverNodeFullScreen: false,
      hoveredSemanticNodesFullScreen: null,
      mousePositionFullScreen: { x: 0, y: 0 },
      tooltipPositionFullScreen: { x: 0, y: 0 },
      activePanelPropagationMapFullScreen: undefined,
      isColorClusterPropagationMapFullScreen: true,
      clustersPropagationMapFullScreen: [],
      isCheckAllPropagationMapFullScreen: true,
      isRotatingRegenerateInsight: false,
      listIndexOpenInsight: [ true ],
      indexOpenInsight: 0,
      dialogPageInsight: false,
      loadingResponseDescribeDashboard: false,
      listResponseDescribeDashboard: [],
      currentOrigin: "",
      devOrigins: [
        'http://localhost',
        'http://172.20.4.11'
      ],
      currentLoadingIndex: 0,
      overlayDialogLoading: false,
      dialogLoading: false,
      isSearch: false,
      abortHashtagController: null,
      currentLoadId: null,
      dialogSearchContext: false,
      searchContextTopic: "",
      searchContextStartDate: "",
      searchContextEndDate: "",
      alert: false,
      colorAlert: "",
      message: "",
      selectedTopic: "",
      selectedKeyword: "",
      selectedPeriode: "This Week",
      valueSelectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      menu: false,
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isShowDate: false,
      showStartDate: "",
      showEndDate: "",
      dialogConfirmReset: false,
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    },
    pageLengthViralPosts() {
      if (!Array.isArray(this.listViralPosts) || this.listViralPosts.length === 0) return 0;
      return Math.ceil(this.listViralPosts.length / this.perPageViralPosts);
    },
    paginatedViralPosts() {
      if (!Array.isArray(this.listViralPosts)) return [];
      const start = (this.pageViralPosts - 1) * this.perPageViralPosts;
      const end = start + this.perPageViralPosts;
      return this.listViralPosts.slice(start, end);
    },
    clusterFilterOptions() {
      const all = [{ name: "all", label: "All Clusters" }];
      return [
        ...all,
        ...this.clustersPropagationMap.map(c => ({
          name: c.name,
          label: c.label
        }))
      ];
    }
  },
  mounted() {
    this.loadTopic();
    document.addEventListener('fullscreenchange', this.handleFullScreenChange);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('fullscreenchange', this.handleFullScreenChange);
    this.cleanupScene();
    this.cleanupFullScreen();
  },
  methods: {
    async loadViral() {
      trackEvent('viral',
        {
          topic: this.searchContextTopic,
          keyword: this.selectedKeyword,
          period: this.selectedPeriode
        }
      );

      const loadId = Date.now();
      this.currentLoadId = loadId;

      if (this.abortHashtagController) {
        this.abortHashtagController.abort();
      }

      this.alert = false;
      this.colorAlert = "";
      this.message = "";
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        await Promise.all([
          this.loadPublicSentiment(),
          this.loadSourceBreakdown(),
          this.loadViralPosts(),
          this.loadHashtags(),
          this.loadTrendingPhrases(),
          this.loadMentions(),
        ]);

        if (this.currentLoadId == loadId) {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          if (this.isSearch == true) {
            this.openDialogSearchContext();
          }
        } else {
          console.log("Dialog tetap terbuka karena ada loadViral baru yang sedang jalan");
        }
      } catch (e) {
        console.error(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    async loadPublicSentiment() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formatDate = (dateStr) => {
          if (!dateStr) return null;
          const [year, month, day] = dateStr.split('-');
          return `${day}-${month}-${year}`;
        };

        const formattedStart = formatDate(this.$store.date_start_glob);
        const formattedEnd = formatDate(this.$store.date_end_glob);

        const keywords = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value)
          .join(',');

        const response = await axios.post(
          `/viral-data`,
          {
            api_type: "sentiments",
            keywords,
            start_time: formattedStart,
            end_time: formattedEnd,
            socmed: ["twitter", "youtube"],
          },
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const dataTwitter = response.data?.data?.twitter || {};
        const dataYoutube = response.data?.data?.youtube || {};

        const countTwitter = dataTwitter.count_sentiment || {};
        const countYoutube = dataYoutube.count_sentiment || {};

        const totalTwitter = dataTwitter.total_post || 0;
        const totalYoutube = dataYoutube.total_post || 0;

        const negative = (countTwitter.Negative || 0) + (countYoutube.Negative || 0);
        const neutral = (countTwitter.Neutral || 0) + (countYoutube.Neutral || 0);
        const positive = (countTwitter.Positive || 0) + (countYoutube.Positive || 0);
        const total = negative + neutral + positive;

        if (total > 0) {
          this.persenPublicSentimentNegative = Math.round((negative / total) * 100);
          this.persenPublicSentimentNeutral = Math.round((neutral / total) * 100);
          this.persenPublicSentimentPositive = Math.round((positive / total) * 100);
        } else {
          this.persenPublicSentimentNegative = 0;
          this.persenPublicSentimentNeutral = 0;
          this.persenPublicSentimentPositive = 0;
        }

        const timelyTwitter = dataTwitter.timely_sentiment || [];
        const timelyYoutube = dataYoutube.timely_sentiment || [];

        const timelyMap = {};

        const mergeTimely = (arr, stripTime = false) => {
          arr.forEach(item => {
            const label = stripTime ? item.time_label.split(' ')[0] : item.time_label;

            if (!timelyMap[label]) {
              timelyMap[label] = { time_label: label, Total: 0, Negative: 0, Neutral: 0, Positive: 0 };
            }
            timelyMap[label].Total += item.Total || 0;
            timelyMap[label].Negative += item.Negative || 0;
            timelyMap[label].Neutral += item.Neutral || 0;
            timelyMap[label].Positive += item.Positive || 0;
          });
        };

        mergeTimely(timelyTwitter, false);
        mergeTimely(timelyYoutube, true);

        const parseTimeLabel = (label) => {
          const [datePart, timePart] = label.split(' ');
          const [day, month, year] = datePart.split('-');
          return new Date(`${year}-${month}-${day}T${timePart || '00:00'}`);
        };

        const mergedTimely = Object.values(timelyMap).sort(
          (a, b) => parseTimeLabel(a.time_label) - parseTimeLabel(b.time_label)
        );

        const categories = mergedTimely.map(item => item.time_label);
        const seriesNegative = mergedTimely.map(item =>
          item.Total > 0 ? Math.round((item.Negative / item.Total) * 100) : 0
        );
        const seriesNeutral = mergedTimely.map(item =>
          item.Total > 0 ? Math.round((item.Neutral / item.Total) * 100) : 0
        );
        const seriesPositive = mergedTimely.map(item =>
          item.Total > 0 ? Math.round((item.Positive / item.Total) * 100) : 0
        );

        this.optionsPublicSentiment = {
          ...this.optionsPublicSentiment,
          xaxis: {
            ...this.optionsPublicSentiment.xaxis,
            categories
          },
          yaxis: {
            min: 0,
            max: 100,
            tickAmount: 2,
            labels: {
              formatter: val => val.toFixed(0) + '%'
            }
          }
        };

        this.seriesPublicSentiment = [
          { name: "Negative", data: seriesNegative },
          { name: "Neutral", data: seriesNeutral },
          { name: "Positive", data: seriesPositive }
        ];

        this.sourceCollectionTotals.twitter = totalTwitter;
        this.sourceCollectionTotals.youtube = totalYoutube;
        this.sourceCollectionTotals.tiktok = 0;
        this.sourceCollectionTotals.instagram = 0;
        this.sourceCollectionTotals.facebook = 0;

        window.dispatchEvent(new Event("resize"));
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.persenPublicSentimentNegative = 0;
              this.persenPublicSentimentNeutral = 0;
              this.persenPublicSentimentPositive = 0;
              this.seriesPublicSentiment = [
                { name: "Negative", data: [] },
                { name: "Neutral", data: [] },
                { name: "Positive", data: [] }
              ];
              this.sourceCollectionTotals = {
                twitter: 0,
                youtube: 0,
                tiktok: 0,
                instagram: 0,
                facebook: 0,
              };

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral Sentiments Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral Sentiments Response Data Not Found";
          this.colorAlert = "red";
        }

        window.dispatchEvent(new Event("resize"));
      }
    },
    getSourceCollectionTotal(name) {
      if (name == 'twitter') return this.sourceCollectionTotals.twitter
      if (name == 'youtube') return this.sourceCollectionTotals.youtube
      if (name == 'tiktok') return this.sourceCollectionTotals.tiktok
      if (name == 'instagram') return this.sourceCollectionTotals.instagram
      if (name == 'facebook') return this.sourceCollectionTotals.facebook
      return 0
    },
    getSourceCollectionLabel(name) {
      switch (name.toLowerCase()) {
        case 'twitter':
          return 'Twitter';
        case 'youtube':
          return 'Youtube';
        case 'tiktok':
          return 'TikTok';
        case 'instagram':
          return 'Instagram';
        case 'facebook':
          return 'Facebook';
        default:
          return name;
      }
    },
    async loadSourceBreakdown() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formatDate = (dateStr) => {
          if (!dateStr) return null;
          const [year, month, day] = dateStr.split('-');
          return `${day}-${month}-${year}`;
        };

        const formattedStart = formatDate(this.$store.date_start_glob);
        const formattedEnd = formatDate(this.$store.date_end_glob);

        const keywords = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value)
          .join(',');

        const response = await axios.post(
          `/viral-data`,
          {
            api_type: "user",
            keywords,
            start_time: formattedStart,
            end_time: formattedEnd,
            socmed: ["twitter", "youtube"],
          },
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const dataTwitter = response.data?.data?.twitter || {};
        const dataYoutube = response.data?.data?.youtube || {};

        let regularUserCount = 0;
        let influencerCount = 0;
        let buzzerCount = 0;

        const accumulateSegmentation = (segmentationArr) => {
          if (!Array.isArray(segmentationArr)) return;
          segmentationArr.forEach(segment => {
            switch (segment.user_type) {
              case "regular_user":
                regularUserCount += segment.count || 0;
                break;
              case "influencer":
                influencerCount += segment.count || 0;
                break;
              case "buzzer":
                buzzerCount += segment.count || 0;
                break;
            }
          });
        };

        accumulateSegmentation(dataTwitter.user_segmentation?.twitter);
        accumulateSegmentation(dataYoutube.user_segmentation?.youtube);

        this.seriesSourceBreakdown = [regularUserCount, influencerCount, buzzerCount];
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.seriesSourceBreakdown = [0, 0, 0];

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral User Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral User Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    async loadViralPosts() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formatDate = (dateStr) => {
          if (!dateStr) return null;
          const [year, month, day] = dateStr.split('-');
          return `${day}-${month}-${year}`;
        };

        const formattedStart = formatDate(this.$store.date_start_glob);
        const formattedEnd = formatDate(this.$store.date_end_glob);

        const keywords = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value)
          .join(',');

        const response = await axios.post(
          `/viral-data`,
          {
            api_type: "viral",
            keywords,
            start_time: formattedStart,
            end_time: formattedEnd,
            socmed: ["twitter", "youtube"],
          },
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const rawTwitter = response.data?.data?.twitter?.twitter?.data;
        const rawYoutube = response.data?.data?.youtube?.youtube?.data;

        const dataTwitter = Array.isArray(rawTwitter) ? rawTwitter : [];
        const dataYoutube = Array.isArray(rawYoutube) ? rawYoutube : [];

        const normalizedTwitter = dataTwitter.map(item => ({
          id: item.id,
          socmed: "twitter",
          user_name: item.user_name,
          user_screen_name: item.user_screen_name,
          user_profile_image_url: item.user_profile_image_url,
          verified: item.verified__b,
          text: item.text,
          created_at: item.created_at,
          reply_count: item.reply_count__s || 0,
          share_count: (item.retweet_count || 0) + (item.quote_count || 0),
          like_count: item.like__s || 0,
          view_count: item.view_count || 0,
          url: null,
        }));

        const normalizedYoutube = dataYoutube.map(item => ({
          id: item.id || item.v_id,
          socmed: "youtube",
          user_name: item.v_channel_name,
          user_screen_name: item.v_channel_name,
          user_profile_image_url: null,
          channel_id: item.v_channel_id,
          verified: false,
          text: item.title,
          created_at: item.dateid || item.p_created_at,
          reply_count: (item.v_comment_count__ms && item.v_comment_count__ms[0]) || 0,
          share_count: item.v_subscribe_count || 0,
          like_count: (item.v_like_count__ms && item.v_like_count__ms[0]) || 0,
          view_count: (item.v_view_count__ms && item.v_view_count__ms[0]) || 0,
          url: item.url,
        }));

        const merged = [...normalizedTwitter, ...normalizedYoutube].sort((a, b) => {
          const viewDiff = (b.view_count || 0) - (a.view_count || 0);
          if (viewDiff !== 0) return viewDiff;
          return new Date(b.created_at) - new Date(a.created_at);
        });

        this.listViralPosts = merged;
        this.pageViralPosts = 1;
        this.loadViralPropagationMap();
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.listViralPosts = [];
              this.pageViralPosts = 1;

              this.initialSemanticNodesPropagationMap = [];
              this.semanticNodesPropagationMap = [];
              this.clusterColorPropagationMap = [];
              this.clustersPropagationMap = [];
              this.clustersPropagationMapFullScreen = [];
              this.cleanupThreeScene();
              this.cleanupThreeSceneFullScreen();

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    handlePageChangeViralPosts(page) {
      this.pageViralPosts = page;
      const listEl = this.$refs.viralPostsScrollContainer;
      if (listEl) {
        listEl.scrollTop = 0;
      }
    },
    formatCreatedAt(createdAt) {
      if (!createdAt) return '';

      const date = new Date(createdAt);
      const now = new Date();
      const diffHours = Math.floor((now - date) / (1000 * 60 * 60));

      if (diffHours < 1) {
        const diffMinutes = Math.floor((now - date) / (1000 * 60));
        return `${diffMinutes}m`;
      } else if (diffHours < 24) {
        return `${diffHours}h`;
      } else {
        const diffDays = Math.floor(diffHours / 24);
        return `${diffDays}d`;
      }
    },
    formatCount(count) {
      if (!count && count != 0) return '0';

      const num = parseInt(count);
      if (isNaN(num)) return '0';

      return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1
      }).format(num);
    },
    async loadHashtags() {
      this.valueHashtags = "";
      this.seriesHashtags = [
        {
          name: "Data Asli",
          type: "scatter",
          data: []
        },
        {
          name: "GAM Prediction",
          type: "line",
          data: []
        }
      ];
      this.allHashtags = [];

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        this.abortHashtagController = new AbortController();
        const { signal } = this.abortHashtagController;

        const selectedTopic = this.topicSentiment.find(
          item => item.SEQ_ID == this.$store.topic_glob
        )?.TOPIC;

        const periodeMap = {
          "Today": "TODAY",
          "From Yesterday": "FROM_YESTERDAY",
          "This Week": "THIS_WEEK",
          "Previous Week": "PREVIOUS_WEEK",
          "This Month": "THIS_MONTH",
          "Previous Month": "PREVIOUS_MONTH",
        };

        const valueSelectedPeriode = periodeMap[this.selectedPeriode];

        const response = await axios.post(
          "/analysis-generate-json",
          {
            api_type: "hashtag",
            topic: selectedTopic,
            period: valueSelectedPeriode,
            mode: "full",
          },
          {
            headers: {
              'auth-token': authToken,
            },
            signal,
          }
        );

        const data = response.data?.data || [];

        if (data.length > 0) {
          this.allHashtags = data;
          this.currentHashtagIndex = 0;
          this.valueHashtags = data[0].hashtag_lower;
          this.updateHashtagChartData(0);
        }
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
            case 400:
            case 500:
              this.valueHashtags = "";
              this.seriesHashtags = [
                {
                  name: "Data Asli",
                  type: "scatter",
                  data: []
                },
                {
                  name: "GAM Prediction",
                  type: "line",
                  data: []
                }
              ];
              this.allHashtags = [];

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral Hashtag Response Data Not Found";
              this.colorAlert = "red";
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral Hashtag Response Data Not Found";
          this.colorAlert = "red";
        }
      } finally {
        this.abortHashtagController = null;
      }
    },
    updateHashtagChartData(index) {
      if (!this.allHashtags[index]) return;

      const hashtagData = this.allHashtags[index];
      const metrics = hashtagData.hashtag_trends?.metrics || {};
      const changePoints = hashtagData.hashtag_trends?.change_points || [];
      const gamPrediction = metrics.gam_prediction || {};
      const rawData = metrics.raw_data || {};
      const confidenceInterval = metrics.confidence_interval || {};
      const futurePrediction = metrics.future_prediction || {};

      let categories = metrics.x_axis?.values || [];
      const rawDataValues = rawData.values || [];
      const gamDataValues = gamPrediction.values
        ? gamPrediction.values.map(value => Number(parseFloat(value).toFixed(2)))
        : [];

      const lowerBound = confidenceInterval.lower_bound || [];
      const upperBound = confidenceInterval.upper_bound || [];
      const futureCategories = futurePrediction.x_axis || [];
      const futureData = futurePrediction.y_axis
        ? futurePrediction.y_axis.map(value => parseFloat(value).toFixed(2))
        : [];
      const futureCILower = futurePrediction.lower_bound || [];
      const futureCIUpper = futurePrediction.upper_bound || [];

      let series = [
        {
          name: "Data Asli",
          type: "scatter",
          data: rawDataValues,
        },
        {
          name: "GAM Prediction",
          type: "line",
          data: gamDataValues,
        },
      ];

      const isPredictionSelected = this.selectedHashtags.includes("Prediksi 7 Hari Ke Depan");
      const isFutureCISelected = this.selectedHashtags.includes("Future CI");

      if (isPredictionSelected || isFutureCISelected) {
        const extendedCategories = [...categories, ...futureCategories];
        const nullPadding = new Array(futureCategories.length).fill(null);

        series[0].data = [...rawDataValues, ...nullPadding];
        series[1].data = [...gamDataValues, ...nullPadding];
        categories = extendedCategories;
      }

      if (isPredictionSelected) {
        series.push({
          name: "Prediksi 7 Hari",
          type: "line",
          data: [...new Array(categories.length - futureData.length).fill(null), ...futureData.map(Number)],
        });
      }

      if (isFutureCISelected && futureCILower.length > 0 && futureCIUpper.length > 0) {
        const pad = new Array(categories.length - futureCILower.length).fill(null);
        series.push({
          name: "Future CI Upper Bound",
          type: "area",
          data: [...pad, ...futureCIUpper.map(v => parseFloat(v).toFixed(2))],
        });
        series.push({
          name: "Future CI Lower Bound",
          type: "area",
          data: [...pad, ...futureCILower.map(v => parseFloat(v).toFixed(2))],
        });
      }

      this.selectedHashtags.forEach(selection => {
        switch (selection) {
          case "Simultaneous CI (95%)":
            series.push({
              name: "Simultaneous CI (95%) Upper Bound",
              type: "area",
              data: upperBound.map(v => parseFloat(v).toFixed(2)),
            });
            series.push({
              name: "Simultaneous CI (95%) Lower Bound",
              type: "area",
              data: lowerBound.map(v => parseFloat(v).toFixed(2)),
            });
            break;

          case "Change Point":
            break;

          case "Mean per Segment":
            if (changePoints.length > 0) {
              const actualDates = metrics.x_axis?.values || [];
              const meanSeriesData = new Array(categories.length).fill(null);

              for (let i = 0; i < changePoints.length; i++) {
                const startDate = changePoints[i].date;
                let startIdx = actualDates.indexOf(startDate);
                if (startIdx == -1) startIdx = 0;

                let endIdx;
                if (i < changePoints.length - 1) {
                  let nextIdx = actualDates.indexOf(changePoints[i + 1].date);
                  if (nextIdx == -1) nextIdx = actualDates.length;
                  endIdx = nextIdx - 1;
                } else {
                  endIdx = actualDates.length - 1;
                }

                const meanValue = parseFloat(changePoints[i].segment_average);
                for (let j = startIdx; j <= endIdx; j++) {
                  meanSeriesData[j] = meanValue;
                }
              }

              series.push({
                name: "Mean per Segment",
                type: "line",
                data: meanSeriesData,
              });
            }
            break;
        }
      });

      this.seriesHashtags = series;
      this.seriesHashtagsExpanded = JSON.parse(JSON.stringify(series));
      this.updateChartOptions(categories, hashtagData);
    },
    updateChartOptions(categories, hashtagData) {
      let strokeWidth = [0, 3];
      let strokeColors = ['#808080', '#2B4A6F'];
      let fillColors = ['#808080', '#2B4A6F'];
      let fillOpacity = [1, 1];
      let markerSizes = [5, 0];
      let dashArray = [0, 0];
      let fillTypes = ['solid', 'solid'];
      let curveArray = ['smooth', 'smooth'];

      for (let i = 2; i < this.seriesHashtags.length; i++) {
        const seriesName = this.seriesHashtags[i].name;

        if (seriesName.includes('Simultaneous CI')) {
          strokeWidth.push(2);
          strokeColors.push('#94ddf7');
          fillColors.push(seriesName.includes('Upper') ? '#94ddf7' : '#FFFFFF');
          fillOpacity.push(seriesName.includes('Upper') ? 0.5 : 1.0);
          markerSizes.push(0);
          dashArray.push(0);
          fillTypes.push('solid');
          curveArray.push('smooth');
        } else if (seriesName.includes('Future CI')) {
          strokeWidth.push(2);
          strokeColors.push('#f7c9b9');
          fillColors.push(seriesName.includes('Upper') ? '#f7c9b9' : '#FFFFFF');
          fillOpacity.push(seriesName.includes('Upper') ? 0.3 : 1.0);
          markerSizes.push(0);
          dashArray.push(0);
          fillTypes.push('solid');
          curveArray.push('smooth');
        } else if (seriesName.includes('Prediksi')) {
          const futurePrediction = hashtagData?.hashtag_trends?.metrics?.future_prediction || {};
          const predictionColor = futurePrediction.prediction_trend == "Naik"  ? '#008000' :
                                  futurePrediction.prediction_trend == "Turun" ? '#ff0000' : '#2B4A6F';
          strokeWidth.push(3);
          strokeColors.push(predictionColor);
          fillColors.push(predictionColor);
          fillOpacity.push(1);
          markerSizes.push(0);
          dashArray.push(5);
          fillTypes.push('solid');
          curveArray.push('smooth');
        } else if (seriesName.includes('Mean')) {
          strokeWidth.push(2);
          strokeColors.push('#1A18D7');
          fillColors.push('#1A18D7');
          fillOpacity.push(1);
          markerSizes.push(0);
          dashArray.push(4);
          fillTypes.push('solid');
          curveArray.push('stepline');
        }
      }

      let xaxisAnnotations = [];
      if (this.selectedHashtags.includes("Change Point") && hashtagData?.hashtag_trends?.change_points) {
        xaxisAnnotations = hashtagData.hashtag_trends.change_points.map(cp => ({
          x: cp.date,
          borderColor: '#FF9800',
          strokeDashArray: 4,
          borderWidth: 2,
          label: { show: false },
        }));
      }

      let pointAnnotations = [];
      if (
        this.selectedHashtags.includes("Mean per Segment") &&
        hashtagData?.hashtag_trends?.change_points?.length > 0
      ) {
        const changePoints = hashtagData.hashtag_trends.change_points;
        const actualDates = hashtagData.hashtag_trends?.metrics?.x_axis?.values || [];

        changePoints.forEach((cp) => {
          let startIdx = actualDates.indexOf(cp.date);
          if (startIdx == -1) startIdx = 0;

          const meanValue = parseFloat(cp.segment_average);
          const xCategory = categories[startIdx];

          pointAnnotations.push({
            x: xCategory,
            y: meanValue,
            marker: { size: 0 },
            label: {
              borderColor: 'transparent',
              borderRadius: 3,
              text: meanValue.toFixed(2),
              style: {
                background: 'transparent',
                color: '#000000',
                fontSize: '11px',
                fontWeight: 'bold',
              },
              offsetY: -8,
              offsetX: 4,
            },
          });
        });
      }

      const newOptions = {
        ...this.optionsHashtags,
        xaxis: {
          ...this.optionsHashtags.xaxis,
          categories,
          type: 'category',
        },
        annotations: {
          xaxis: xaxisAnnotations,
          points: pointAnnotations,
        },
        stroke: {
          curve: curveArray,
          width: strokeWidth,
          colors: strokeColors,
          dashArray,
        },
        fill: {
          ...this.optionsHashtags.fill,
          type: fillTypes,
          colors: fillColors,
          opacity: fillOpacity,
        },
        markers: {
          ...this.optionsHashtags.markers,
          size: markerSizes,
        },
        colors: strokeColors,
        dataLabels: {
          enabled: false,
        },
      };

      this.optionsHashtags = newOptions;
      this.optionsHashtagsExpanded = JSON.parse(JSON.stringify(newOptions));
    },
    handleLeftClickHashtags() {
      if (!this.allHashtags.length) return;

      this.currentHashtagIndex = (this.currentHashtagIndex - 1 + this.allHashtags.length) % this.allHashtags.length;
      this.valueHashtags = this.allHashtags[this.currentHashtagIndex].hashtag_lower;

      this.updateHashtagChartData(this.currentHashtagIndex);
    },
    handleRightClickHashtags() {
      if (!this.allHashtags.length) return;

      this.currentHashtagIndex = (this.currentHashtagIndex + 1) % this.allHashtags.length;
      this.valueHashtags = this.allHashtags[this.currentHashtagIndex].hashtag_lower;

      this.updateHashtagChartData(this.currentHashtagIndex);
    },
    async loadTrendingPhrases() {
      this.allWordsTrendingPhrases = "";
      this.wordsTrendingPhrases = [];

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formatDate = (dateStr) => {
          if (!dateStr) return null;
          const [year, month, day] = dateStr.split('-');
          return `${day}-${month}-${year}`;
        };

        const formattedStart = formatDate(this.$store.date_start_glob);
        const formattedEnd = formatDate(this.$store.date_end_glob);

        const keywords = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value)
          .join(',');

        const response = await axios.post(
          `/viral-data`,
          {
            api_type: "words",
            keywords,
            start_time: formattedStart,
            end_time: formattedEnd,
            socmed: ["twitter", "youtube"],
          },
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const dataTwitter = response.data?.data?.twitter || {};
        const dataYoutube = response.data?.data?.youtube || {};

        const phrasesTwitter = dataTwitter.common_phrases || {};
        const phrasesYoutube = dataYoutube.common_phrases || {};

        const mergedPhrases = {};

        const accumulatePhrases = (phrasesObj) => {
          Object.entries(phrasesObj).forEach(([phrase, count]) => {
            mergedPhrases[phrase] = (mergedPhrases[phrase] || 0) + (count || 0);
          });
        };

        accumulatePhrases(phrasesTwitter);
        accumulatePhrases(phrasesYoutube);

        if (Object.keys(mergedPhrases).length > 0) {
          this.allWordsTrendingPhrases = { common_phrases: mergedPhrases };

          this.wordsTrendingPhrases = Object.entries(mergedPhrases)
            .map(([phrase, count]) => ({
              name: phrase,
              value: count
            }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 100);
        }
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.allWordsTrendingPhrases = "";
              this.wordsTrendingPhrases = [];

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral Words Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral Words Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    handleLeftClickTrendingPhrases() {
      this.selectedTrendingPhrases = "Common Phrases";
      this.currentTrendingPhrasesIndex = 0;
      this.wordsTrendingPhrases = Object.entries(this.allWordsTrendingPhrases.common_phrases)
        .map(([phrase, count]) => ({
          name: phrase,
          value: count
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 100);
    },
    handleRightClickTrendingPhrases() {
      this.selectedTrendingPhrases = "Common Words";
      this.currentTrendingPhrasesIndex = 1;
      this.wordsTrendingPhrases = Object.entries(this.allWordsTrendingPhrases.common_words)
        .map(([phrase, count]) => ({
          name: phrase,
          value: count
        }))
        .sort((a, b) => b.value - a.value)
        .slice(0, 100);
    },
    async loadMentions() {
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formatDate = (dateStr) => {
          if (!dateStr) return null;
          const [year, month, day] = dateStr.split('-');
          return `${day}-${month}-${year}`;
        };

        const formattedStart = formatDate(this.$store.date_start_glob);
        const formattedEnd = formatDate(this.$store.date_end_glob);

        const response = await axios.post(
          `/viral-data`,
          {
            "api_type": "impact",
            "keywords": this.topicKeywordSentiment
              .filter(item => item.value != "All")
              .map(item => item.value)
              .join(','),
            "start_time" : formattedStart,
            "end_time" : formattedEnd,
            "socmed" : "twitter"
          },
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const bubbleData = response.data?.data?.bubble_chart_influencer?.data || [];

        const sortedData = bubbleData
          .sort((a, b) => b.total_post - a.total_post)
          .slice(0, 10);

        const minValue = Math.min(...sortedData.map(e => e.total_post));
        const maxValue = Math.max(...sortedData.map(e => e.total_post));

        const minSize = 40;
        const maxSize = 160;

        const scaleSize = (value) => {
          if (maxValue == minValue) return (minSize + maxSize) / 2;
          return minSize + ((value - minValue) / (maxValue - minValue)) * (maxSize - minSize);
        };

        const allSameSize = sortedData.every(e => e.total_post == sortedData[0].total_post);

        const positionTemplate = allSameSize
          ? [
              { top: 10, left: 0 },
              { top: -10, left: 150 },
              { top: 10, left: 300 },
              { top: 120, left: 30 },
              { top: 115, left: 160 },
              { top: 120, left: 290 },
              { top: 225, left: 60 },
              { top: 225, left: 200 },
              { top: 225, left: 320 },
              { top: 320, left: 130 }
            ]
          : [
              { top: 20, left: -20 },
              { top: -10, left: 150 },
              { top: 20, left: 320 },
              { top: 195, left: 30 },
              { top: 170, left: 180 },
              { top: 175, left: 300 },
              { top: 280, left: 160 },
              { top: 280, left: 260 },
              { top: 280, left: 330 },
              { top: 340, left: 220 }
            ];

        this.mentions = sortedData.map((entity, index) => ({
          name: entity.name,
          size: scaleSize(entity.total_post),
          top: positionTemplate[index]?.top || 0,
          left: positionTemplate[index]?.left || 0,
          image: entity.profpic,
          follower: entity.follower,
          totalPost: entity.total_post,
        }));
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.mentions = "";

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Viral Impact Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Viral Impact Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    showTooltipMentions(entity, event) {
      this.tooltipMentions.visible = true;
      this.tooltipMentions.data = entity;
      this.moveTooltipMentions(event);
    },
    moveTooltipMentions(event) {
      this.tooltipMentions.top = event.clientY - 100;
      this.tooltipMentions.left = event.clientX + 20;
    },
    hideTooltipMentions() {
      this.tooltipMentions.visible = false;
    },
    async loadViralPropagationMap() {
      this.loadDataSendTopicLatest();

      try {
        this.cleanupThreeScene();
        this.cleanupThreeSceneFullScreen();

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const selectedTopic = this.topicSentiment.find(
          item => item.SEQ_ID == this.$store.topic_glob
        )?.TOPIC;

        const periodeMap = {
          "Today": "TODAY",
          "From Yesterday": "FROM_YESTERDAY",
          "This Week": "THIS_WEEK",
          "Previous Week": "PREVIOUS_WEEK",
          "This Month": "THIS_MONTH",
          "Previous Month": "PREVIOUS_MONTH",
        };

        let valueSelectedPeriode = periodeMap[this.selectedPeriode];

        const response = await axios.post(
          "/analysis-generate-json",
          {
            api_type: "semantic",
            topic: selectedTopic,
            proc_date: valueSelectedPeriode,
            collection: "twitter",
          },
          {
            headers: {
              "auth-token": authToken,
            },
          }
        );

        if (response.data && response.data.payload && response.data.payload.nodes) {
          this.initialSemanticNodesPropagationMap = response.data.payload.nodes;
          this.generateSemanticNodes(response.data.payload.nodes);
          this.generateClustersFromNodes(response.data.payload.nodes);

          await this.$nextTick();
          this.initThree();
          window.addEventListener('resize', this.handleResize);
        }
      } catch (e) {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            case 400:
            case 500:
              this.initialSemanticNodesPropagationMap = [];
              this.semanticNodesPropagationMap = [];
              this.clusterColorPropagationMap = [];
              this.clustersPropagationMap = [];
              this.clustersPropagationMapFullScreen = [];
              this.cleanupThreeScene();
              this.cleanupThreeSceneFullScreen();

              this.alert = true;
              setTimeout(() => {
                this.alert = false;
              }, 10000);
              this.message = "API Generate JSON Response Data Not Found";
              this.colorAlert = "red";
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Generate JSON Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    async loadDataSendTopicLatest() {
      try {
        const authToken = localStorage.getItem('token_app');
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        let periode = this.$store.selectedPeriode_glob.toUpperCase().replace(/ /g, '_');
        const topic = this.$store.topic_glob;

        const endpoints = ['SCHEDULER SEMANTIC GROUPING', 'SEMANTIC'];

        const results = [];

        for (const endpoint of endpoints) {
          const response = await axios.get(
            `data-send-topic-last-calculated?periode=${periode}&topic=${topic}&endpoint=${endpoint}`,
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const result = response?.data?.data?.result;

          if (Array.isArray(result) && result.length > 0 && result[0].CREATED_AT) {
            results.push(result[0]);
          }
        }

        if (results.length > 0) {
          const latest = results.reduce((a, b) => a.SEQ_ID > b.SEQ_ID ? a : b);
          this.lastCalculatedOn = this.formatDateReadable(latest.CREATED_AT);
        } else {
          this.lastCalculatedOn = '-';
        }
      } catch (error) {
        this.lastCalculatedOn = '-';
      }
    },
    formatDateReadable(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year] = datePart.split('-');

      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr',
        'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ];

      const monthName = monthNames[parseInt(month) - 1];

      return `${day} ${monthName} ${year}, ${timePart}`;
    },
    generateSemanticNodes(nodes) {
      this.semanticNodesPropagationMap = [];

      const engagementCounts = [];

      nodes.forEach((node) => {
        const viralPosts = this.listViralPosts.filter(post => {
          const statusIdFromUrl = post.url__s?.split('/status/')[1];
          return (
            post.user_screen_name == node.user_name &&
            statusIdFromUrl == node.id
          );
        });

        if (viralPosts.length > 0) {
          const engagementCount = parseInt(viralPosts[0].latest_viral_score) || 0;
          engagementCounts.push(engagementCount);
        }
      });

      const minEngagement = Math.min(...engagementCounts);
      const maxEngagement = Math.max(...engagementCounts);

      const minSize = 2;
      const maxSize = 10;

      const scaleSize = (engagementCount) => {
        if (engagementCount <= 0) return minSize;

        const logMin = Math.log10(Math.max(minEngagement, 1));
        const logMax = Math.log10(Math.max(maxEngagement, 1));
        const logValue = Math.log10(engagementCount);

        const normalized = logMax > logMin
          ? (logValue - logMin) / (logMax - logMin)
          : 0.5;

        return minSize + (normalized * (maxSize - minSize));
      };

      nodes.forEach((node, index) => {
        const viralPosts = this.listViralPosts.filter(post => {
          const statusIdFromUrl = post.url__s?.split('/status/')[1];
          return (
            post.user_screen_name == node.user_name &&
            statusIdFromUrl == node.id
          );
        });

        if (viralPosts.length > 0) {
          const engagementCount = parseInt(viralPosts[0].latest_viral_score) || 0;
          const scaledSize = scaleSize(engagementCount);

          this.semanticNodesPropagationMap.push({
            userName: node.user_name,
            image: viralPosts[0].user_profile_image_url,
            engagement: engagementCount,
            totalPost: node.total_post,
            viralPosts,
            positionX: node.x,
            positionY: node.y,
            positionZ: node.z,
            size: scaledSize,
            color: "",
            userId: node.user_id,
            clusterId: node.cluster_label,
            createdDate: node.created_date,
            nodeId: node.id,
            nodeIndex: index
          });
        }
      });
    },
    generateClustersFromNodes(nodes) {
      const clusterGroups = {};

      nodes.forEach((node) => {
        const clusterLabel = node.cluster_label;
        if (!clusterGroups[clusterLabel]) {
          clusterGroups[clusterLabel] = [];
        }
        clusterGroups[clusterLabel].push(node);
      });

      const totalNodes = nodes.length;
      const colorPalette = [
        "#c27640",
        "#cdcb9e",
        "#dca93e",
        "#a248d5",
        "#8d6e63",
        "#e08a2e",
        "#c9438b",
        "#ddc9a3",
        "#bfa58a",
        "#d6a1b4",
      ];

      this.clustersPropagationMap = [];
      this.clusterColorPropagationMap = [];

      const normalClusters = Object.entries(clusterGroups)
        .filter(([label]) => label != "-1")
        .sort((a, b) => b[1].length - a[1].length);

      const noiseCluster = clusterGroups["-1"] ? [["-1", clusterGroups["-1"]]] : [];

      const getTopEngagementUsername = (nodesInCluster) => {
        let topNode = null;
        let topEngagement = -1;

        nodesInCluster.forEach(node => {
          const semanticNode = this.semanticNodesPropagationMap.find(
            sn => sn.nodeId == node.id
          );
          const engagement = semanticNode?.engagement || 0;
          if (engagement > topEngagement) {
            topEngagement = engagement;
            topNode = node;
          }
        });

        return topNode?.user_name || nodesInCluster[0]?.user_name || "Unknown";
      };

      let clusterIndex = 0;
      normalClusters.forEach(([clusterLabel, nodesInCluster]) => {
        const clusterSize = nodesInCluster.length;
        const percentage = ((clusterSize / totalNodes) * 100).toFixed(2);

        const color = colorPalette[clusterIndex % colorPalette.length];
        clusterIndex++;

        const label = getTopEngagementUsername(nodesInCluster);

        this.clustersPropagationMap.push({
          name: clusterLabel,
          label,
          color: color,
          checked: true,
          percentage: percentage
        });

        if (!this.clusterColorPropagationMap.find((item) => item.name == clusterLabel)) {
          this.clusterColorPropagationMap.push({
            color,
            name: clusterLabel
          });
        }
      });

      noiseCluster.forEach(([clusterLabel, nodesInCluster]) => {
        const clusterSize = nodesInCluster.length;
        const percentage = ((clusterSize / totalNodes) * 100).toFixed(2);
        const color = "#D3D3D3";

        this.clustersPropagationMap.push({
          name: clusterLabel,
          label: "Outer Cluster",
          color: color,
          checked: true,
          percentage: percentage
        });

        if (!this.clusterColorPropagationMap.find((item) => item.name == clusterLabel)) {
          this.clusterColorPropagationMap.push({
            color,
            name: clusterLabel
          });
        }
      });

      this.semanticNodesPropagationMap.forEach((node) => {
        const apiNode = nodes.find(n => n.id == node.nodeId);
        if (apiNode) {
          const cluster = this.clustersPropagationMap.find(
            c => c.name == apiNode.cluster_label
          );
          node.color = cluster ? cluster.color : "#D3D3D3";
        }
      });
    },
    loadColorClusterNode() {
      this.isColorClusterPropagationMap = true;

      if (this.dialogFullScreen == false) {
        this.loadColorClusterNodeFullScreen();
      }

      this.generateClustersFromNodes(this.initialSemanticNodesPropagationMap);

      this.semanticNodesPropagationMap.forEach(node => {
        const cluster = this.clustersPropagationMap.find(c => c.name == node.clusterId);
        const clusterColor = cluster ? cluster.color : "#D3D3D3";

        node.color = clusterColor;

        if (node.sphereRef) {
          node.sphereRef.material.color.set(clusterColor);
          node.sphereRef.visible = true;
        }

        if (node.labelRef) {
          const oldLabel = node.labelRef;
          const newLabel = this.createTextSprite(node.userName, clusterColor);

          newLabel.position.copy(oldLabel.position);
          newLabel.userData = oldLabel.userData;

          if (this.group) {
            this.group.remove(oldLabel);
            this.group.add(newLabel);
          }

          if (oldLabel.material && oldLabel.material.map) {
            oldLabel.material.map.dispose();
          }
          if (oldLabel.material) {
            oldLabel.material.dispose();
          }

          node.labelRef = newLabel;
        }

        if (node.imageSpriteRef) {
          node.imageSpriteRef.visible = true;
        }

        if (node.nodeGroupRef) {
          node.nodeGroupRef.visible = true;
        }
      });

      this.updateCheckAllStatusClustersPropagationMap();
    },
    loadColorSentimentNode() {
      this.isColorClusterPropagationMap = false;

      if (this.dialogFullScreen == false) {
        this.loadColorSentimentNodeFullScreen();
      }

      const sentimentColors = {
        'Positive': '#45af5b',
        'Negative': '#ff1752',
        'Neutral': '#008ffb'
      };

      this.semanticNodesPropagationMap.forEach(node => {
        let nodeColor = '#D3D3D3';

        if (node.viralPosts && node.viralPosts.length > 0) {
          const sentiment = node.viralPosts[0].sentiment__s;
          nodeColor = sentimentColors[sentiment] || '#D3D3D3';
        }

        node.color = nodeColor;

        if (node.sphereRef) {
          node.sphereRef.material.color.set(nodeColor);
        }

        if (node.labelRef) {
          const oldLabel = node.labelRef;
          const newLabel = this.createTextSprite(node.userName, nodeColor);

          newLabel.position.copy(oldLabel.position);
          newLabel.userData = oldLabel.userData;

          if (this.group) {
            this.group.remove(oldLabel);
            this.group.add(newLabel);
          }

          if (oldLabel.material && oldLabel.material.map) {
            oldLabel.material.map.dispose();
          }
          if (oldLabel.material) {
            oldLabel.material.dispose();
          }

          node.labelRef = newLabel;
        }
      });

      const sentimentStats = {
        'Positive': 0,
        'Negative': 0,
        'Neutral': 0
      };

      let totalNodesWithSentiment = 0;

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.viralPosts && node.viralPosts.length > 0) {
          const sentiment = node.viralPosts[0].sentiment__s;
          if (Object.hasOwn(sentimentStats, sentiment)) {
            sentimentStats[sentiment]++;
            totalNodesWithSentiment++;
          }
        }
      });

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.nodeGroupRef) {
          node.nodeGroupRef.visible = true;
        }

        if (node.labelRef) {
          node.labelRef.visible = true;
        }
      });

      this.clustersPropagationMap = [];

      Object.entries(sentimentStats).forEach(([sentiment, count]) => {
        const percentage = totalNodesWithSentiment > 0
          ? ((count / totalNodesWithSentiment) * 100).toFixed(2)
          : '0.00';

        this.clustersPropagationMap.push({
          name: sentiment,
          label: sentiment,
          color: sentimentColors[sentiment],
          checked: true,
          percentage: percentage
        });
      });

      this.clustersPropagationMap.sort((a, b) => parseFloat(b.percentage) - parseFloat(a.percentage));
      this.updateCheckAllStatusClustersPropagationMap();
    },
    clickCheckAllPropagationMap() {
      this.clustersPropagationMap.forEach(cluster => {
        cluster.checked = this.isCheckAllPropagationMap;
      });

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.nodeGroupRef) {
          node.nodeGroupRef.visible = this.isCheckAllPropagationMap;
        }

        if (node.labelRef) {
          node.labelRef.visible = this.isCheckAllPropagationMap;
        }
      });
    },
    toggleClusterPropagationMap(clusterName) {
      const cluster = this.clustersPropagationMap.find(c => c.name == clusterName);
      if (!cluster) return;

      const isVisible = cluster.checked;

      let nodesInCluster;

      if (this.isColorClusterPropagationMap) {
        nodesInCluster = this.semanticNodesPropagationMap.filter(
          node => node.clusterId == clusterName
        );
      } else {
        nodesInCluster = this.semanticNodesPropagationMap.filter(node => {
          if (node.viralPosts && node.viralPosts.length > 0) {
            return node.viralPosts[0].sentiment__s == clusterName;
          }
          return false;
        });
      }

      nodesInCluster.forEach(node => {
        if (node.nodeGroupRef) {
          node.nodeGroupRef.visible = isVisible;
        }

        if (node.labelRef) {
          node.labelRef.visible = isVisible;
        }
      });

      this.updateCheckAllStatusClustersPropagationMap();
    },
    updateCheckAllStatusClustersPropagationMap() {
      const allChecked = this.clustersPropagationMap.every(c => c.checked);
      const allUnchecked = this.clustersPropagationMap.every(c => !c.checked);

      if (allChecked) {
        this.isCheckAllPropagationMap = true;
      } else if (allUnchecked) {
        this.isCheckAllPropagationMap = false;
      }
    },
    async applyAdvancedSemantic() {
      try {
        this.isLoadingAdvancedSemantic = true;
        this.advancedSemanticError = "";
        this.loadingStep = 1;

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const selectedTopic = this.searchContextTopic;

        const keywordString = this.topicKeywordSentiment
          .filter(item => item.value != "All")
          .map(item => item.value)
          .join(",");

        const periodeMap = {
          "Today": "TODAY",
          "From Yesterday": "FROM_YESTERDAY",
          "This Week": "THIS_WEEK",
          "Previous Week": "PREVIOUS_WEEK",
          "This Month": "THIS_MONTH",
          "Previous Month": "PREVIOUS_MONTH",
        };
        const valueSelectedPeriode = periodeMap[this.selectedPeriode];

        const formatDate = (dateStr) => {
          const [year, month, day] = dateStr.split("-");
          return `${day}-${month}-${year}`;
        };
        const startTime = formatDate(this.startDate);
        const endTime = formatDate(this.endDate);

        const minimalDistance = this.semanticMinimalDistance != "" ? parseFloat(this.semanticMinimalDistance) : 1;
        const spreadness = this.semanticSpreadness != "" ? parseFloat(this.semanticSpreadness) : 1.5;

        const payload = {
          topic: selectedTopic,
          keyword: [{ collection: "twitter", collection_solr: "Twitter", keyword: keywordString }],
          period: valueSelectedPeriode,
          start_time: startTime,
          end_time: endTime,
          type: "bigram",
          window_size: 2,
          mode: "custom",
          lower_bound: null,
          n_neighbors: 2,
          min_cluster_size: 5,
          min_dist: minimalDistance,
          spread: spreadness,
        };

        const response = await axios.post("/recalculate-semantic", payload, {
          headers: { "auth-token": authToken },
          validateStatus: () => true,
        });

        trackEvent("viral-semantic",
          {
            topic: selectedTopic,
            proc_date: valueSelectedPeriode,
            collection: "twitter",
            min_dist: minimalDistance,
            spread: spreadness
          }
        );

        if (response.data?.response == "FAILED") {
          if (response.data?.error == "min_dist must be less than or equal to spread") {
            this.advancedSemanticError = "Minimal Distance must be less than or equal to Spreadness.";
          } else {
            this.advancedSemanticError = response.data?.error || "An error occurred.";
          }

          setTimeout(() => {
            this.advancedSemanticError = "";
          }, 10000);

          return;
        }

        if (response.data?.payload?.nodes) {
          const nodes = response.data.payload.nodes;

          this.loadingStep = 2;
          this.cleanupThreeScene();
          this.cleanupThreeSceneFullScreen();

          this.semanticNodesPropagationMap = [];
          this.clustersPropagationMap = [];
          this.hoveredSemanticNodes = null;
          this.searchNodeUsername = "";
          this.selectedFilterCluster = "all";
          this.initialSemanticNodesPropagationMap = nodes;

          this.generateSemanticNodes(nodes);
          this.generateClustersFromNodes(nodes);

          this.loadingStep = 3;
          await this.$nextTick();
          this.initThree();
          this.initThreeFullScreen();
          window.addEventListener('resize', this.handleResize);
        }
      } catch (error) {
        console.error("Error applying advanced semantic:", error);
        trackEvent("viral-semantic-failed");
        this.advancedSemanticError = "Unexpected error occurred. Please try again.";
        setTimeout(() => {
          this.advancedSemanticError = "";
        }, 10000);
      } finally {
        this.isLoadingAdvancedSemantic = false;
        this.loadingStep = 0;
      }
    },
    initThree() {
      const container = this.$refs.containerRef;
      if (!container) return;

      const scale = 2;

      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0x000000);

      this.camera = new THREE.PerspectiveCamera(
        15,
        container.clientWidth / container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.z = 30;

      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setClearColor(0x000000, 1);
      container.appendChild(this.renderer.domElement);

      const canvas = this.renderer.domElement;
      canvas.addEventListener('mousedown', this.handleMouseDownPropagationMap);
      canvas.addEventListener('mousemove', this.handleMouseMovePropagationMap);
      canvas.addEventListener('mouseup', this.handleMouseUpPropagationMap);
      canvas.addEventListener('mouseleave', this.handleMouseLeavePropagationMap);
      canvas.addEventListener('wheel', this.handleWheelPropagationMap, { passive: false });

      this.group = new THREE.Group();
      this.scene.add(this.group);

      this.tunnelGroup = new THREE.Group();
      this.scene.add(this.tunnelGroup);
      this.createWireframeTunnel();

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      this.scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(5, 5, 5);
      this.scene.add(directionalLight);

      if (!this.dotTexture) {
        this.dotTexture = this.makeDotTexture(64);
      }

      this.createSemanticMap(this.group, scale);

      if (this.sharedRotation && this.group) {
        this.group.rotation.set(
          this.sharedRotation.x,
          this.sharedRotation.y,
          this.sharedRotation.z
        );
      }

      this.animate();
    },
    createWireframeTunnel() {
      const material = new THREE.LineBasicMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0.5,
        depthWrite: false,
      });

      const W = 32;
      const H = 18;
      const D = 120;
      const halfW = W / 2;
      const halfH = H / 2;

      const zNear = 42;
      const zFar = zNear - D;

      const gridX = 14;
      const gridY = 8;
      const gridZ = 20;

      const pts = [];
      const ln = (x1,y1,z1, x2,y2,z2) => {
        pts.push(
          new THREE.Vector3(x1, y1, z1),
          new THREE.Vector3(x2, y2, z2)
        );
      };

      for (let i = 0; i <= gridX; i++) {
        const x = -halfW + (W / gridX) * i;
        ln(x, -halfH, zNear,  x, -halfH, zFar);
      }

      for (let i = 0; i <= gridZ; i++) {
        const z = zFar + (D / gridZ) * i;
        ln(-halfW, -halfH, z,  halfW, -halfH, z);
      }

      for (let i = 0; i <= gridX; i++) {
        const x = -halfW + (W / gridX) * i;
        ln(x, halfH, zNear,  x, halfH, zFar);
      }

      for (let i = 0; i <= gridZ; i++) {
        const z = zFar + (D / gridZ) * i;
        ln(-halfW, halfH, z,  halfW, halfH, z);
      }

      for (let i = 0; i <= gridY; i++) {
        const y = -halfH + (H / gridY) * i;
        ln(-halfW, y, zNear,  -halfW, y, zFar);
      }

      for (let i = 0; i <= gridZ; i++) {
        const z = zFar + (D / gridZ) * i;
        ln(-halfW, -halfH, z,  -halfW, halfH, z);
      }

      for (let i = 0; i <= gridY; i++) {
        const y = -halfH + (H / gridY) * i;
        ln(halfW, y, zNear,  halfW, y, zFar);
      }

      for (let i = 0; i <= gridZ; i++) {
        const z = zFar + (D / gridZ) * i;
        ln(halfW, -halfH, z,  halfW, halfH, z);
      }

      for (let i = 0; i <= gridX; i++) {
        const x = -halfW + (W / gridX) * i;
        ln(x, -halfH, zFar,  x, halfH, zFar);
      }

      for (let i = 0; i <= gridY; i++) {
        const y = -halfH + (H / gridY) * i;
        ln(-halfW, y, zFar,  halfW, y, zFar);
      }

      const geometry = new THREE.BufferGeometry().setFromPoints(pts);
      const tunnel = new THREE.LineSegments(geometry, material);
      this.tunnelGroup.add(tunnel);
    },
    makeDotTexture(size = 64) {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = size;
      const ctx = canvas.getContext('2d');
      const r = size / 2;

      ctx.beginPath();
      ctx.arc(r, r, r * 0.80, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.fill();

      return new THREE.CanvasTexture(canvas);
    },
    createSemanticMap(group, scale) {
      const nodeScale = 3;

      const hitGeoCache = {};
      const getHitGeo = (r) => {
        const key = Math.round(r * 10);
        if (!hitGeoCache[key]) {
          hitGeoCache[key] = new THREE.SphereGeometry(r * 1.1, 16, 12);
        }
        return hitGeoCache[key];
      };

      this.semanticNodesPropagationMap.forEach((word, index) => {
        const radius = 0.08 * nodeScale;

        const borderRadius = radius * 1.10;
        const numBorderDots = Math.max(500, Math.round(borderRadius * borderRadius * 50000));
        const borderGeo = this.buildDottedSphere(borderRadius, numBorderDots);
        const borderDotSize = Math.max(0.012, borderRadius * 0.14);

        const borderMat = new THREE.PointsMaterial({
          color: new THREE.Color(0x000000),
          size: borderDotSize,
          sizeAttenuation: true,
          map: this.dotTexture,
          transparent: true,
          opacity: 1.0,
          alphaTest: 0.3,
          depthWrite: false,
          blending: THREE.NormalBlending,
        });

        const borderMesh = new THREE.Points(borderGeo, borderMat);
        borderMesh.renderOrder = 1;

        const numDots = Math.max(300, Math.round(radius * radius * 40000));
        const pointsGeo = this.buildDottedSphere(radius, numDots);
        const dotSize = Math.max(0.008, radius * 0.11);

        const pointsMat = new THREE.PointsMaterial({
          color: new THREE.Color(word.color),
          size: dotSize,
          sizeAttenuation: true,
          map: this.dotTexture,
          transparent: true,
          opacity: 0.92,
          alphaTest: 0.4,
          depthWrite: false,
          blending: THREE.NormalBlending,
        });

        const pointsMesh = new THREE.Points(pointsGeo, pointsMat);
        pointsMesh.renderOrder = 2;

        const hitGeo = getHitGeo(radius);
        const hitMat = new THREE.MeshBasicMaterial({
          visible: false,
          side: THREE.FrontSide
        });
        const hitMesh = new THREE.Mesh(hitGeo, hitMat);

        const x = word.sharedPosition ? word.sharedPosition.x : (word.positionX / scale);
        const y = word.sharedPosition ? word.sharedPosition.y : (word.positionY / scale);
        const z = word.sharedPosition ? word.sharedPosition.z : (word.positionZ / scale);

        const nodeGroup = new THREE.Group();
        nodeGroup.add(borderMesh);
        nodeGroup.add(pointsMesh);
        nodeGroup.add(hitMesh);
        nodeGroup.position.set(x, y, z);

        nodeGroup.userData = { index, word, isNode: true };
        hitMesh.userData = { index, word, isNode: true };

        group.add(nodeGroup);

        const label = this.createTextSprite(word.userName, word.color);
        label.position.set(x, y - 0.4, z);
        label.userData = { isLabel: true };
        group.add(label);

        word.sphereRef = pointsMesh;
        word.borderRef = borderMesh;
        word.labelRef = label;
        word.hitMeshRef = hitMesh;
        word.nodeGroupRef = nodeGroup;
        word.nodePosition = { x, y, z };

        if (!word.sharedPosition) {
          word.sharedPosition = { x, y, z };
        }
      });

      const sorted = [...this.semanticNodesPropagationMap].sort(
        (a, b) => a.nodePosition.z - b.nodePosition.z
      );

      sorted.forEach((word, i) => {
        const base = (i + 1) * 10;
        if (word.borderRef)  word.borderRef.renderOrder  = base + 1;
        if (word.sphereRef)  word.sphereRef.renderOrder  = base + 2;
        if (word.labelRef)   word.labelRef.renderOrder   = base + 3;
      });
    },
    buildDottedSphere(radius, numPts) {
      const positions = new Float32Array(numPts * 3);
      const goldenAngle = Math.PI * (1 + Math.sqrt(5));

      for (let i = 0; i < numPts; i++) {
        const t = (i + 0.5) / numPts;
        const phi = Math.acos(1 - 2 * t);
        const theta = goldenAngle * i;

        positions[i * 3] = radius * Math.sin(phi) * Math.cos(theta);
        positions[i * 3 + 1] = radius * Math.sin(phi) * Math.sin(theta);
        positions[i * 3 + 2] = radius * Math.cos(phi);
      }

      const geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      return geo;
    },
    createTextSprite(text, color) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const fontSize = 42;
      context.font = `600 ${fontSize}px Arial`;

      const textWidth = context.measureText(text).width;
      canvas.width = textWidth + 40;
      canvas.height = fontSize + 30;

      context.font = `600 ${fontSize}px Arial`;
      context.fillStyle = color;
      context.textAlign = "center";
      context.textBaseline = "middle";

      context.shadowColor = "rgba(0, 0, 0, 0.8)";
      context.shadowBlur = 12;
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 0;

      context.fillText(text, canvas.width / 2, canvas.height / 2);

      const texture = new THREE.CanvasTexture(canvas);
      texture.minFilter = THREE.LinearFilter;
      texture.generateMipmaps = false;

      const material = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: false,
        blending: THREE.AdditiveBlending,
      });

      const sprite = new THREE.Sprite(material);
      const spriteScale = 0.003;
      sprite.scale.set(
        canvas.width * spriteScale,
        canvas.height * spriteScale,
        1
      );

      return sprite;
    },
    animate() {
      if (!this.renderer || !this.scene || !this.camera) return;
      requestAnimationFrame(this.animate);

      this.semanticNodesPropagationMap.forEach(word => {
        if (word.nodeGroupRef) {
          const targetScale = (this.hoveredSemanticNodes &&
                             this.hoveredSemanticNodes.nodeId == word.nodeId) ? 1.15 : 1.0;
          word.nodeGroupRef.scale.lerp(
            new THREE.Vector3(targetScale, targetScale, targetScale),
            0.1
          );
        }
      });

      this.renderer.render(this.scene, this.camera);
    },
    cleanupThreeScene() {
      window.removeEventListener('resize', this.handleResize);

      if (this.renderer && this.renderer.domElement) {
        const canvas = this.renderer.domElement;
        canvas.removeEventListener('mousedown', this.handleMouseDownPropagationMap);
        canvas.removeEventListener('mousemove', this.handleMouseMovePropagationMap);
        canvas.removeEventListener('mouseup', this.handleMouseUpPropagationMap);
        canvas.removeEventListener('mouseleave', this.handleMouseLeavePropagationMap);
        canvas.removeEventListener('wheel', this.handleWheelPropagationMap);
      }

      if (this.scene) {
        this.scene.traverse((object) => {
          if (object.geometry) object.geometry.dispose();
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach(material => {
                if (material.map) material.map.dispose();
                material.dispose();
              });
            } else {
              if (object.material.map) object.material.map.dispose();
              object.material.dispose();
            }
          }
        });

        while (this.scene.children.length > 0) {
          this.scene.remove(this.scene.children[0]);
        }

        this.scene = null;
      }

      if (this.tunnelGroup) {
        this.tunnelGroup.traverse((obj) => {
          if (obj.geometry) obj.geometry.dispose();
          if (obj.material) obj.material.dispose();
        });
        this.tunnelGroup = null;
      }

      const container = this.$refs.containerRef;
      if (container && this.renderer && this.renderer.domElement) {
        try {
          container.removeChild(this.renderer.domElement);
        } catch (e) {
          console.warn('Could not remove renderer element:', e);
        }
      }

      if (this.renderer) {
        this.renderer.dispose();
        this.renderer.forceContextLoss();
        this.renderer.domElement = null;
        this.renderer = null;
      }

      if (this.dotTexture) {
        this.dotTexture.dispose();
        this.dotTexture = null;
      }

      this.camera = null;
    },
    initThreeFullScreen() {
      const container = this.$refs.containerRefFullScreen;
      if (!container) return;

      const scale = 2;

      this.sceneFullScreen = new THREE.Scene();
      this.sceneFullScreen.background = new THREE.Color(0x000000);

      this.cameraFullScreen = new THREE.PerspectiveCamera(
        20,
        container.clientWidth / container.clientHeight,
        0.1,
        1000
      );
      this.cameraFullScreen.position.z = 30;

      this.rendererFullScreen = new THREE.WebGLRenderer({ antialias: true });
      this.rendererFullScreen.setSize(container.clientWidth, container.clientHeight);
      this.rendererFullScreen.setPixelRatio(window.devicePixelRatio);
      this.rendererFullScreen.setClearColor(0x000000, 1);
      container.appendChild(this.rendererFullScreen.domElement);

      const canvas = this.rendererFullScreen.domElement;
      canvas.addEventListener('mousedown', this.handleMouseDownFullScreen);
      canvas.addEventListener('mousemove', this.handleMouseMoveFullScreen);
      canvas.addEventListener('mouseup', this.handleMouseUpFullScreen);
      canvas.addEventListener('mouseleave', this.handleMouseLeaveFullScreen);
      canvas.addEventListener('wheel', this.handleWheelFullScreen, { passive: false });

      this.groupFullScreen = new THREE.Group();
      this.sceneFullScreen.add(this.groupFullScreen);

      this.tunnelGroup = new THREE.Group();
      this.sceneFullScreen.add(this.tunnelGroup);
      this.createWireframeTunnel();

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      this.sceneFullScreen.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(5, 5, 5);
      this.sceneFullScreen.add(directionalLight);

      if (!this.dotTexture) {
        this.dotTexture = this.makeDotTexture(64);
      }

      this.clustersPropagationMapFullScreen = JSON.parse(JSON.stringify(this.clustersPropagationMap));

      this.createSemanticMapFullScreen(this.groupFullScreen, scale);

      if (this.sharedRotation && this.groupFullScreen) {
        this.groupFullScreen.rotation.set(
          this.sharedRotation.x,
          this.sharedRotation.y,
          this.sharedRotation.z
        );
      }

      this.animateFullScreen();
    },
    createSemanticMapFullScreen(group, scale) {
      const nodeScale = 3;

      const hitGeoCache = {};
      const getHitGeo = (r) => {
        const key = Math.round(r * 10);
        if (!hitGeoCache[key]) {
          hitGeoCache[key] = new THREE.SphereGeometry(r * 1.1, 16, 12);
        }
        return hitGeoCache[key];
      };

      this.semanticNodesPropagationMap.forEach((word, index) => {
        const radius = 0.08 * nodeScale;

        const borderRadius = radius * 1.10;
        const numBorderDots = Math.max(500, Math.round(borderRadius * borderRadius * 50000));
        const borderGeo = this.buildDottedSphere(borderRadius, numBorderDots);
        const borderDotSize = Math.max(0.012, borderRadius * 0.14);

        const borderMat = new THREE.PointsMaterial({
          color: new THREE.Color(0x000000),
          size: borderDotSize,
          sizeAttenuation: true,
          map: this.dotTexture,
          transparent: true,
          opacity: 1.0,
          alphaTest: 0.3,
          depthWrite: false,
          blending: THREE.NormalBlending,
        });

        const borderMesh = new THREE.Points(borderGeo, borderMat);
        borderMesh.renderOrder = 1;

        const numDots = Math.max(300, Math.round(radius * radius * 40000));
        const pointsGeo = this.buildDottedSphere(radius, numDots);
        const dotSize = Math.max(0.008, radius * 0.11);

        const pointsMat = new THREE.PointsMaterial({
          color: new THREE.Color(word.color),
          size: dotSize,
          sizeAttenuation: true,
          map: this.dotTexture,
          transparent: true,
          opacity: 0.92,
          alphaTest: 0.4,
          depthWrite: false,
          blending: THREE.NormalBlending,
        });

        const pointsMesh = new THREE.Points(pointsGeo, pointsMat);
        pointsMesh.renderOrder = 2;

        const hitGeo = getHitGeo(radius);
        const hitMat = new THREE.MeshBasicMaterial({
          visible: false,
          side: THREE.FrontSide
        });
        const hitMesh = new THREE.Mesh(hitGeo, hitMat);

        const x = word.sharedPosition ? word.sharedPosition.x : (word.positionX / scale);
        const y = word.sharedPosition ? word.sharedPosition.y : (word.positionY / scale);
        const z = word.sharedPosition ? word.sharedPosition.z : (word.positionZ / scale);

        const nodeGroup = new THREE.Group();
        nodeGroup.add(borderMesh);
        nodeGroup.add(pointsMesh);
        nodeGroup.add(hitMesh);
        nodeGroup.position.set(x, y, z);

        nodeGroup.userData = { index, word, isNode: true };
        hitMesh.userData = { index, word, isNode: true };

        group.add(nodeGroup);

        const label = this.createTextSprite(word.userName, word.color);
        label.position.set(x, y - 0.4, z);
        label.userData = { isLabel: true };
        group.add(label);

        word.sphereRefFullScreen = pointsMesh;
        word.borderRefFullScreen = borderMesh;
        word.labelRefFullScreen = label;
        word.hitMeshRefFullScreen = hitMesh;
        word.nodeGroupRefFullScreen = nodeGroup;
        word.nodePositionFullScreen = { x, y, z };

        if (!word.sharedPosition) {
          word.sharedPosition = { x, y, z };
        }
      });

      const sorted = [...this.semanticNodesPropagationMap].sort(
        (a, b) => a.nodePositionFullScreen.z - b.nodePositionFullScreen.z
      );

      sorted.forEach((word, i) => {
        const base = (i + 1) * 10;
        if (word.borderRefFullScreen)  word.borderRefFullScreen.renderOrder  = base + 1;
        if (word.sphereRefFullScreen)  word.sphereRefFullScreen.renderOrder  = base + 2;
        if (word.labelRefFullScreen)   word.labelRefFullScreen.renderOrder   = base + 3;
      });
    },
    animateFullScreen() {
      if (!this.rendererFullScreen || !this.sceneFullScreen || !this.cameraFullScreen) return;
      requestAnimationFrame(this.animateFullScreen);

      this.semanticNodesPropagationMap.forEach(word => {
        if (word.nodeGroupRefFullScreen) {
          const targetScale = (this.hoveredSemanticNodesFullScreen &&
                              this.hoveredSemanticNodesFullScreen.nodeId == word.nodeId) ? 1.15 : 1.0;
          word.nodeGroupRefFullScreen.scale.lerp(
            new THREE.Vector3(targetScale, targetScale, targetScale),
            0.1
          );
        }
      });

      this.rendererFullScreen.render(this.sceneFullScreen, this.cameraFullScreen);
    },
    cleanupThreeSceneFullScreen() {
      if (this.rendererFullScreen && this.rendererFullScreen.domElement) {
        const canvas = this.rendererFullScreen.domElement;
        canvas.removeEventListener('mousedown', this.handleMouseDownFullScreen);
        canvas.removeEventListener('mousemove', this.handleMouseMoveFullScreen);
        canvas.removeEventListener('mouseup', this.handleMouseUpFullScreen);
        canvas.removeEventListener('mouseleave', this.handleMouseLeaveFullScreen);
        canvas.removeEventListener('wheel', this.handleWheelFullScreen);
      }

      if (this.sceneFullScreen) {
        this.sceneFullScreen.traverse((object) => {
          if (object.geometry) object.geometry.dispose();
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach(material => {
                if (material.map) material.map.dispose();
                material.dispose();
              });
            } else {
              if (object.material.map) object.material.map.dispose();
              object.material.dispose();
            }
          }
        });

        while (this.sceneFullScreen.children.length > 0) {
          this.sceneFullScreen.remove(this.sceneFullScreen.children[0]);
        }

        this.sceneFullScreen = null;
      }

      if (this.tunnelGroup) {
        this.tunnelGroup.traverse((obj) => {
          if (obj.geometry) obj.geometry.dispose();
          if (obj.material) obj.material.dispose();
        });
        this.tunnelGroup = null;
      }

      const container = this.$refs.containerRefFullScreen;
      if (container && this.rendererFullScreen && this.rendererFullScreen.domElement) {
        try {
          container.removeChild(this.rendererFullScreen.domElement);
        } catch (e) {
          console.warn('Could not remove fullscreen renderer element:', e);
        }
      }

      if (this.rendererFullScreen) {
        this.rendererFullScreen.dispose();
        this.rendererFullScreen.forceContextLoss();
        this.rendererFullScreen.domElement = null;
        this.rendererFullScreen = null;
      }

      this.cameraFullScreen = null;
    },
    handleResize() {
      const container = this.$refs.containerRef;
      if (!container || !this.camera || !this.renderer) return;

      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    handleMouseDownPropagationMap(e) {
      const container = this.$refs.containerRef;
      if (!container) return;

      const rect = container.getBoundingClientRect();
      this.mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;

      this.raycaster.setFromCamera(this.mouse, this.camera);

      const hitMeshes = this.semanticNodesPropagationMap
        .map(node => node.hitMeshRef)
        .filter(mesh => mesh);

      const intersects = this.raycaster.intersectObjects(hitMeshes, false);

      if (intersects.length > 0) {
        const word = intersects[0].object.userData.word;
        this.isDraggingNode = true;
        this.draggedSemanticNode = word;
        this.cursorStylePropagationMap = 'grabbing';
      } else {
        this.isDragging = true;
        this.previousMouse = { x: e.clientX, y: e.clientY };
      }
    },
    handleMouseMovePropagationMap(e) {
      const container = this.$refs.containerRef;
      if (!container || !this.group) return;

      const rect = container.getBoundingClientRect();
      this.mousePosition = { x: e.clientX, y: e.clientY };

      this.mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;

      if (this.isDraggingNode && this.draggedSemanticNode) {
        this.hoveredSemanticNodes = null;

        const word = this.draggedSemanticNode;

        const nodeWorldPos = new THREE.Vector3();
        word.nodeGroupRef.getWorldPosition(nodeWorldPos);
        const nodeNDC = nodeWorldPos.clone().project(this.camera);

        const mouseNDC = new THREE.Vector3(
          this.mouse.x,
          this.mouse.y,
          nodeNDC.z
        );
        const newWorldPos = mouseNDC.unproject(this.camera);
        const localPos = this.group.worldToLocal(newWorldPos.clone());

        word.nodeGroupRef.position.set(localPos.x, localPos.y, localPos.z);
        word.labelRef.position.set(localPos.x, localPos.y - 0.4, localPos.z);

        word.sharedPosition = { x: localPos.x, y: localPos.y, z: localPos.z };

        return;
      }

      if (this.isDragging) {
        const dx = e.clientX - this.previousMouse.x;
        const dy = e.clientY - this.previousMouse.y;

        this.group.rotation.y += dx * 0.01;
        this.group.rotation.x += dy * 0.01;

        this.previousMouse = { x: e.clientX, y: e.clientY };
        this.hoveredSemanticNodes = null;

        this.sharedRotation = {
          x: this.group.rotation.x,
          y: this.group.rotation.y,
          z: this.group.rotation.z
        };
        return;
      }

      this.raycaster.setFromCamera(this.mouse, this.camera);

      const hitMeshes = this.semanticNodesPropagationMap
        .map(node => node.hitMeshRef)
        .filter(mesh => mesh);

      const intersects = this.raycaster.intersectObjects(hitMeshes, false);

      if (intersects.length > 0) {
        const intersectedNode = intersects[0].object.userData.word;

        let nodeCluster;
        if (this.isColorClusterPropagationMap) {
          nodeCluster = this.clustersPropagationMap.find(
            cluster => cluster.name == intersectedNode.clusterId
          );
        } else {
          if (intersectedNode.viralPosts && intersectedNode.viralPosts.length > 0) {
            const sentiment = intersectedNode.viralPosts[0].sentiment__s;
            nodeCluster = this.clustersPropagationMap.find(
              cluster => cluster.name == sentiment
            );
          }
        }

        if (nodeCluster && nodeCluster.checked) {
          this.isOverNode = true;
          this.hoveredSemanticNodes = intersectedNode;
          this.calculateTooltipPosition(e.clientX, e.clientY);
          this.cursorStylePropagationMap = 'grab';
        } else {
          this.isOverNode = false;
          this.hoveredSemanticNodes = null;
          this.cursorStylePropagationMap = 'default';
        }
      } else {
        this.isOverNode = false;
        this.hoveredSemanticNodes = null;
        this.cursorStylePropagationMap = 'default';
      }
    },
    calculateTooltipPosition(mouseX, mouseY) {
      const tooltipHeight = 500;
      const tooltipWidth = 340;
      const offset = 15;
      const padding = 10;

      let x = mouseX + offset;
      let y = mouseY - 80;

      if (x + tooltipWidth > window.innerWidth - padding) {
        x = mouseX - tooltipWidth - offset;
      }

      if (x < padding) {
        x = padding;
      }

      if (y + tooltipHeight > window.innerHeight - padding) {
        y = window.innerHeight - tooltipHeight - padding;
      }

      if (y < padding) {
        y = padding;
      }

      this.tooltipPosition = { x, y };
    },
    handleMouseUpPropagationMap() {
      if (this.isDraggingNode && this.draggedSemanticNode) {
        const word = this.draggedSemanticNode;
        if (word.sharedPosition && word.nodeGroupRefFullScreen) {
          word.nodeGroupRefFullScreen.position.set(
            word.sharedPosition.x,
            word.sharedPosition.y,
            word.sharedPosition.z
          );
          word.labelRefFullScreen.position.set(
            word.sharedPosition.x,
            word.sharedPosition.y - 0.4,
            word.sharedPosition.z
          );
        }
      }

      if (this.isDragging && this.groupFullScreen && this.sharedRotation) {
        this.groupFullScreen.rotation.set(
          this.sharedRotation.x,
          this.sharedRotation.y,
          this.sharedRotation.z
        );
      }

      this.isDragging = false;
      this.isDraggingNode = false;
      this.draggedSemanticNode = null;
      this.cursorStylePropagationMap = 'default';
    },
    handleMouseLeavePropagationMap() {
      this.isDragging = false;
      this.isDraggingNode = false;
      this.draggedSemanticNode = null;
      this.isOverNode = false;
      this.hoveredSemanticNodes = null;
      this.cursorStylePropagationMap = 'default';
    },
    handleWheelPropagationMap(event) {
      event.preventDefault();
      if (event.deltaY < 0) {
        this.zoomInPropagationMap();
      } else {
        this.zoomOutPropagationMap();
      }
    },
    handleWheelFullScreen(event) {
      event.preventDefault();
      if (event.deltaY < 0) {
        this.zoomInFullScreen();
      } else {
        this.zoomOutFullScreen();
      }
    },
    loadColorClusterNodeFullScreen() {
      this.isColorClusterPropagationMapFullScreen = true;

      if (this.dialogFullScreen == true) {
        this.loadColorClusterNode();
      }

      this.generateClustersFromNodes(this.initialSemanticNodesPropagationMap);
      this.clustersPropagationMapFullScreen = JSON.parse(JSON.stringify(this.clustersPropagationMap));

      this.semanticNodesPropagationMap.forEach(node => {
        const cluster = this.clustersPropagationMapFullScreen.find(c => c.name == node.clusterId);
        const clusterColor = cluster ? cluster.color : "#D3D3D3";

        node.color = clusterColor;

        if (node.sphereRefFullScreen) {
          node.sphereRefFullScreen.material.color.set(clusterColor);
          node.sphereRefFullScreen.visible = true;
        }

        if (node.labelRefFullScreen) {
          const oldLabel = node.labelRefFullScreen;
          const newLabel = this.createTextSprite(node.userName, clusterColor);

          newLabel.position.copy(oldLabel.position);
          newLabel.userData = oldLabel.userData;

          if (this.groupFullScreen) {
            this.groupFullScreen.remove(oldLabel);
            this.groupFullScreen.add(newLabel);
          }

          if (oldLabel.material && oldLabel.material.map) {
            oldLabel.material.map.dispose();
          }
          if (oldLabel.material) {
            oldLabel.material.dispose();
          }

          node.labelRefFullScreen = newLabel;
        }

        if (node.imageSpriteRefFullScreen) {
          node.imageSpriteRefFullScreen.visible = true;
        }

        if (node.nodeGroupRefFullScreen) {
          node.nodeGroupRefFullScreen.visible = true;
        }
      });

      this.updateCheckAllStatusClustersFullScreen();
    },
    loadColorSentimentNodeFullScreen() {
      this.isColorClusterPropagationMapFullScreen = false;

      if (this.dialogFullScreen == true) {
        this.loadColorSentimentNode();
      }

      const sentimentColors = {
        'Positive': '#45af5b',
        'Negative': '#ff1752',
        'Neutral': '#008ffb'
      };

      this.semanticNodesPropagationMap.forEach(node => {
        let nodeColor = '#D3D3D3';

        if (node.viralPosts && node.viralPosts.length > 0) {
          const sentiment = node.viralPosts[0].sentiment__s;
          nodeColor = sentimentColors[sentiment] || '#D3D3D3';
        }

        node.color = nodeColor;

        if (node.sphereRefFullScreen) {
          node.sphereRefFullScreen.material.color.set(nodeColor);
        }

        if (node.labelRefFullScreen) {
          const oldLabel = node.labelRefFullScreen;
          const newLabel = this.createTextSprite(node.userName, nodeColor);

          newLabel.position.copy(oldLabel.position);
          newLabel.userData = oldLabel.userData;

          if (this.groupFullScreen) {
            this.groupFullScreen.remove(oldLabel);
            this.groupFullScreen.add(newLabel);
          }

          if (oldLabel.material && oldLabel.material.map) {
            oldLabel.material.map.dispose();
          }
          if (oldLabel.material) {
            oldLabel.material.dispose();
          }

          node.labelRefFullScreen = newLabel;
        }
      });

      const sentimentStats = {
        'Positive': 0,
        'Negative': 0,
        'Neutral': 0
      };

      let totalNodesWithSentiment = 0;

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.viralPosts && node.viralPosts.length > 0) {
          const sentiment = node.viralPosts[0].sentiment__s;
          if (Object.hasOwn(sentimentStats, sentiment)) {
            sentimentStats[sentiment]++;
            totalNodesWithSentiment++;
          }
        }
      });

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.nodeGroupRefFullScreen) {
          node.nodeGroupRefFullScreen.visible = true;
        }

        if (node.labelRefFullScreen) {
          node.labelRefFullScreen.visible = true;
        }
      });

      this.clustersPropagationMapFullScreen = [];

      Object.entries(sentimentStats).forEach(([sentiment, count]) => {
        const percentage = totalNodesWithSentiment > 0
          ? ((count / totalNodesWithSentiment) * 100).toFixed(2)
          : '0.00';

        this.clustersPropagationMapFullScreen.push({
          name: sentiment,
          label: sentiment,
          color: sentimentColors[sentiment],
          checked: true,
          percentage: percentage
        });
      });

      this.clustersPropagationMapFullScreen.sort((a, b) => parseFloat(b.percentage) - parseFloat(a.percentage));
      this.updateCheckAllStatusClustersFullScreen();
    },
    clickCheckAllPropagationMapFullScreen() {
      this.clustersPropagationMapFullScreen.forEach(cluster => {
        cluster.checked = this.isCheckAllPropagationMapFullScreen;
      });

      this.semanticNodesPropagationMap.forEach(node => {
        if (node.nodeGroupRefFullScreen) {
          node.nodeGroupRefFullScreen.visible = this.isCheckAllPropagationMapFullScreen;
        }

        if (node.labelRefFullScreen) {
          node.labelRefFullScreen.visible = this.isCheckAllPropagationMapFullScreen;
        }
      });
    },
    toggleClusterPropagationMapFullScreen(clusterName) {
      const cluster = this.clustersPropagationMapFullScreen.find(c => c.name == clusterName);
      if (!cluster) return;

      const isVisible = cluster.checked;

      let nodesInCluster;

      if (this.isColorClusterPropagationMapFullScreen) {
        nodesInCluster = this.semanticNodesPropagationMap.filter(
          node => node.clusterId == clusterName
        );
      } else {
        nodesInCluster = this.semanticNodesPropagationMap.filter(node => {
          if (node.viralPosts && node.viralPosts.length > 0) {
            return node.viralPosts[0].sentiment__s == clusterName;
          }
          return false;
        });
      }

      nodesInCluster.forEach(node => {
        if (node.nodeGroupRefFullScreen) {
          node.nodeGroupRefFullScreen.visible = isVisible;
        }

        if (node.labelRefFullScreen) {
          node.labelRefFullScreen.visible = isVisible;
        }
      });

      this.updateCheckAllStatusClustersFullScreen();
    },
    updateCheckAllStatusClustersFullScreen() {
      const allChecked = this.clustersPropagationMapFullScreen.every(c => c.checked);
      const allUnchecked = this.clustersPropagationMapFullScreen.every(c => !c.checked);

      if (allChecked) {
        this.isCheckAllPropagationMapFullScreen = true;
      } else if (allUnchecked) {
        this.isCheckAllPropagationMapFullScreen = false;
      }
    },
    handleMouseDownFullScreen(e) {
      const container = this.$refs.containerRefFullScreen;
      if (!container) return;

      const rect = container.getBoundingClientRect();
      this.mouseFullScreen.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouseFullScreen.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;

      this.raycasterFullScreen.setFromCamera(this.mouseFullScreen, this.cameraFullScreen);

      const hitMeshes = this.semanticNodesPropagationMap
        .map(node => node.hitMeshRefFullScreen)
        .filter(mesh => mesh);

      const intersects = this.raycasterFullScreen.intersectObjects(hitMeshes, false);

      if (intersects.length > 0) {
        const word = intersects[0].object.userData.word;
        this.isDraggingNodeFullScreen = true;
        this.draggedSemanticNodeFullScreen = word;
        this.cursorStylePropagationMapFullScreen = 'grabbing';
      } else {
        this.isDraggingFullScreen = true;
        this.previousMouseFullScreen = { x: e.clientX, y: e.clientY };
      }
    },
    handleMouseMoveFullScreen(e) {
      const container = this.$refs.containerRefFullScreen;
      if (!container || !this.groupFullScreen) return;

      const rect = container.getBoundingClientRect();
      this.mousePositionFullScreen = { x: e.clientX, y: e.clientY };

      this.mouseFullScreen.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouseFullScreen.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;

      if (this.isDraggingNodeFullScreen && this.draggedSemanticNodeFullScreen) {
        this.hoveredSemanticNodesFullScreen = null;

        const word = this.draggedSemanticNodeFullScreen;

        const nodeWorldPos = new THREE.Vector3();
        word.nodeGroupRefFullScreen.getWorldPosition(nodeWorldPos);
        const nodeNDC = nodeWorldPos.clone().project(this.cameraFullScreen);

        const mouseNDC = new THREE.Vector3(
          this.mouseFullScreen.x,
          this.mouseFullScreen.y,
          nodeNDC.z
        );
        const newWorldPos = mouseNDC.unproject(this.cameraFullScreen);
        const localPos = this.groupFullScreen.worldToLocal(newWorldPos.clone());

        word.nodeGroupRefFullScreen.position.set(localPos.x, localPos.y, localPos.z);
        word.labelRefFullScreen.position.set(localPos.x, localPos.y - 0.4, localPos.z);

        word.sharedPosition = { x: localPos.x, y: localPos.y, z: localPos.z };

        return;
      }

      if (this.isDraggingFullScreen) {
        const dx = e.clientX - this.previousMouseFullScreen.x;
        const dy = e.clientY - this.previousMouseFullScreen.y;

        this.groupFullScreen.rotation.y += dx * 0.01;
        this.groupFullScreen.rotation.x += dy * 0.01;

        this.previousMouseFullScreen = { x: e.clientX, y: e.clientY };
        this.hoveredSemanticNodesFullScreen = null;

        this.sharedRotation = {
          x: this.groupFullScreen.rotation.x,
          y: this.groupFullScreen.rotation.y,
          z: this.groupFullScreen.rotation.z
        };
        return;
      }

      this.raycasterFullScreen.setFromCamera(this.mouseFullScreen, this.cameraFullScreen);

      const hitMeshes = this.semanticNodesPropagationMap
        .map(node => node.hitMeshRefFullScreen)
        .filter(mesh => mesh);

      const intersects = this.raycasterFullScreen.intersectObjects(hitMeshes, false);

      if (intersects.length > 0) {
        const nodeData = intersects[0].object.userData.word;

        let nodeCluster;
        if (this.isColorClusterPropagationMapFullScreen) {
          nodeCluster = this.clustersPropagationMapFullScreen.find(
            cluster => cluster.name == nodeData.clusterId
          );
        } else {
          if (nodeData.viralPosts && nodeData.viralPosts.length > 0) {
            const sentiment = nodeData.viralPosts[0].sentiment__s;
            nodeCluster = this.clustersPropagationMapFullScreen.find(
              cluster => cluster.name == sentiment
            );
          }
        }

        if (nodeCluster && nodeCluster.checked) {
          this.isOverNodeFullScreen = true;
          this.hoveredSemanticNodesFullScreen = nodeData;
          this.calculateTooltipPositionFullScreen(e.clientX, e.clientY);
          this.cursorStylePropagationMapFullScreen = 'grab';
        } else {
          this.isOverNodeFullScreen = false;
          this.hoveredSemanticNodesFullScreen = null;
          this.cursorStylePropagationMapFullScreen = 'default';
        }
      } else {
        this.isOverNodeFullScreen = false;
        this.hoveredSemanticNodesFullScreen = null;
        this.cursorStylePropagationMapFullScreen = 'default';
      }
    },
    calculateTooltipPositionFullScreen(mouseX, mouseY) {
      const tooltipWidth = 340;
      const tooltipHeight = 500;
      const offset = 15;
      const padding = 10;

      let x = mouseX + offset;
      let y = mouseY - 80;

      if (x + tooltipWidth > window.innerWidth - padding) {
        x = mouseX - tooltipWidth - offset;
      }

      if (x < padding) {
        x = padding;
      }

      if (y + tooltipHeight > window.innerHeight - padding) {
        y = window.innerHeight - tooltipHeight - padding;
      }

      if (y < padding) {
        y = padding;
      }

      this.tooltipPositionFullScreen = { x, y };
    },
    handleMouseUpFullScreen() {
      if (this.isDraggingNodeFullScreen && this.draggedSemanticNodeFullScreen) {
        const word = this.draggedSemanticNodeFullScreen;
        if (word.sharedPosition && word.nodeGroupRef) {
          word.nodeGroupRef.position.set(
            word.sharedPosition.x,
            word.sharedPosition.y,
            word.sharedPosition.z
          );
          word.labelRef.position.set(
            word.sharedPosition.x,
            word.sharedPosition.y - 0.4,
            word.sharedPosition.z
          );
        }
      }

      if (this.isDraggingFullScreen && this.group && this.sharedRotation) {
        this.group.rotation.set(
          this.sharedRotation.x,
          this.sharedRotation.y,
          this.sharedRotation.z
        );
      }

      this.isDraggingFullScreen = false;
      this.isDraggingNodeFullScreen = false;
      this.draggedSemanticNodeFullScreen = null;
      this.cursorStyleFullScreen = 'default';
    },
    handleMouseLeaveFullScreen() {
      this.isDraggingFullScreen = false;
      this.isDraggingNodeFullScreen = false;
      this.draggedSemanticNodeFullScreen = null;
      this.isOverNodeFullScreen = false;
      this.hoveredSemanticNodesFullScreen = null;
      this.cursorStylePropagationMapFullScreen = 'default';
    },
    getActiveCamera() {
      return this.dialogFullScreen ? this.cameraFullScreen : this.camera;
    },
    searchNodesByUsername() {
      const query = this.searchNodeUsername?.toLowerCase().trim();
      if (!query) {
        this.clearSearchNodesByUsername();
        return;
      }
      this.applyNodeVisibility();
    },
    clearSearchNodesByUsername() {
      this.searchNodeUsername = "";
      this.hoveredSemanticNodes = null;
      this.hoveredSemanticNodesFullScreen = null;
      this.selectedFilterCluster = "all";
      this.currentNodeIndex = 0;
      this.applyNodeVisibility();
    },
    updateFilteredNodesByCluster() {
      this.applyNodeVisibility();
    },
    previousNodeByCluster() {
      const clusterList = ["all", ...this.clustersPropagationMap.map(c => c.name)];
      const currentIdx = clusterList.indexOf(this.selectedFilterCluster);
      this.selectedFilterCluster = clusterList[(currentIdx - 1 + clusterList.length) % clusterList.length];
      this.applyNodeVisibility();
    },
    nextNodeByCluster() {
      const clusterList = ["all", ...this.clustersPropagationMap.map(c => c.name)];
      const currentIdx = clusterList.indexOf(this.selectedFilterCluster);
      this.selectedFilterCluster = clusterList[(currentIdx + 1) % clusterList.length];
      this.applyNodeVisibility();
    },
    applyNodeVisibility() {
      const raw = this.searchNodeUsername?.toLowerCase().trim() || "";
      const query = raw.replace(/\s+/g, "");

      this.semanticNodesPropagationMap.forEach(node => {
        const matchCluster = this.selectedFilterCluster == "all"
          || node.clusterId == this.selectedFilterCluster;

        const normalizedUsername = node.userName?.toLowerCase().replace(/\s+/g, "") || "";
        const matchSearch = !query || normalizedUsername.includes(query);
        const isVisible = matchCluster && matchSearch;

        if (node.nodeGroupRef) node.nodeGroupRef.visible = isVisible;
        if (node.labelRef) node.labelRef.visible = isVisible;
        if (node.hitMeshRef) {
          node.hitMeshRef.visible = isVisible;
          node.hitMeshRef.raycast = isVisible
            ? THREE.Mesh.prototype.raycast.bind(node.hitMeshRef)
            : () => {};
        }

        if (node.nodeGroupRefFullScreen) node.nodeGroupRefFullScreen.visible = isVisible;
        if (node.labelRefFullScreen) node.labelRefFullScreen.visible = isVisible;
        if (node.hitMeshRefFullScreen) {
          node.hitMeshRefFullScreen.visible = isVisible;
          node.hitMeshRefFullScreen.raycast = isVisible
            ? THREE.Mesh.prototype.raycast.bind(node.hitMeshRefFullScreen)
            : () => {};
        }
      });

      this.filteredNodesByCluster = this.semanticNodesPropagationMap.filter(node => {
        const matchCluster = this.selectedFilterCluster == "all"
          || node.clusterId == this.selectedFilterCluster;
        const normalizedUsername = node.userName?.toLowerCase().replace(/\s+/g, "") || "";
        const matchSearch = !query || normalizedUsername.includes(query);
        return matchCluster && matchSearch;
      });

      if (this.selectedFilterCluster != "all") {
        this.focusCameraToCluster(this.selectedFilterCluster);
      } else {
        this.resetCameraPosition();
      }
    },
    getActiveCamera() {
      return this.dialogFullScreen ? this.cameraFullScreen : this.camera;
    },
    focusCameraToCluster(clusterId) {
      const activeCamera = this.getActiveCamera();
      if (!activeCamera) return;

      const clusterNodes = this.semanticNodesPropagationMap.filter(
        node => node.clusterId == clusterId && node.nodePosition
      );
      if (clusterNodes.length == 0) return;

      const center = clusterNodes.reduce(
        (acc, node) => {
          acc.x += node.nodePosition.x;
          acc.y += node.nodePosition.y;
          acc.z += node.nodePosition.z;
          return acc;
        },
        { x: 0, y: 0, z: 0 }
      );
      center.x /= clusterNodes.length;
      center.y /= clusterNodes.length;
      center.z /= clusterNodes.length;

      const maxDist = clusterNodes.reduce((max, node) => {
        const dx = node.nodePosition.x - center.x;
        const dy = node.nodePosition.y - center.y;
        return Math.max(max, Math.sqrt(dx * dx + dy * dy));
      }, 0);

      const fovRad = (activeCamera.fov * Math.PI) / 180;
      const distance = Math.max(5, (maxDist * 2.5) / Math.tan(fovRad / 2));

      const finalDistance = distance < 15 ? distance + 15 : distance;
      this.animateCameraTo(center.x, center.y, finalDistance);
    },
    animateCameraTo(targetX, targetY, targetZ) {
      const activeCamera = this.getActiveCamera();
      if (!activeCamera) return;

      const startX = activeCamera.position.x;
      const startY = activeCamera.position.y;
      const startZ = activeCamera.position.z;

      const duration = 600;
      const startTime = performance.now();

      const easeInOut = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      const animateStep = (now) => {
        const cam = this.getActiveCamera();
        if (!cam) return;

        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        const ease = easeInOut(t);

        cam.position.x = startX + (targetX - startX) * ease;
        cam.position.y = startY + (targetY - startY) * ease;
        cam.position.z = startZ + (targetZ - startZ) * ease;

        if (t < 1) {
          requestAnimationFrame(animateStep);
        }
      };

      requestAnimationFrame(animateStep);
    },
    resetCameraPosition() {
      this.animateCameraTo(0, 0, 30);
    },
    zoomInPropagationMap() {
      if (!this.camera) return;
      this.camera.position.z -= 2;
      this.camera.position.z = Math.max(this.camera.position.z, 5);
    },
    zoomOutPropagationMap() {
      if (!this.camera) return;
      this.camera.position.z += 2;
      this.camera.position.z = Math.min(this.camera.position.z, 80);
    },
    zoomInFullScreen() {
      if (!this.cameraFullScreen) return;
      this.cameraFullScreen.position.z -= 2;
      this.cameraFullScreen.position.z = Math.max(this.cameraFullScreen.position.z, 5);
    },
    zoomOutFullScreen() {
      if (!this.cameraFullScreen) return;
      this.cameraFullScreen.position.z += 2;
      this.cameraFullScreen.position.z = Math.min(this.cameraFullScreen.position.z, 80);
    },
    openFullScreen() {
      this.dialogFullScreen = true;

      this.$nextTick(() => {
        const el = this.$refs.fullScreenOverlay;
        if (el && el.requestFullscreen) {
          el.requestFullscreen().catch(err => {
            console.warn('Fullscreen request failed:', err);
          });
        } else if (el && el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        }

        this.initThreeFullScreen();
      });
    },
    closeFullScreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch(err => {
          console.warn('Exit fullscreen failed:', err);
        });
      } else if (document.webkitFullscreenElement) {
        document.webkitExitFullscreen();
      }

      this.dialogFullScreen = false;
      this.cleanupThreeSceneFullScreen();
    },
    handleFullScreenChange() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        if (this.dialogFullScreen) {
          this.dialogFullScreen = false;
          this.cleanupThreeSceneFullScreen();
        }
      }
    },
    cleanupScene() {
      if (this.renderer) {
        this.renderer.dispose();
        const container = this.$refs.containerRef;
        if (container && container.contains(this.renderer.domElement)) {
          container.removeChild(this.renderer.domElement);
        }
      }
    },
    cleanupFullScreen() {
      if (this.rendererFullScreen) {
        this.rendererFullScreen.dispose();
        const container = this.$refs.containerRefFullScreen;
        if (container && container.contains(this.rendererFullScreen.domElement)) {
          container.removeChild(this.rendererFullScreen.domElement);
        }
      }
    },
    regenerateInsight() {
      this.isRotatingRegenerateInsight = true;

      setTimeout(() => {
        this.isRotatingRegenerateInsight = false;
      }, 500);

      this.indexOpenInsight = this.listIndexOpenInsight.length - 1;
      this.listIndexOpenInsight[this.indexOpenInsight] = true;
      this.postDescribeViral();
      this.dialogPageInsight = true;
    },
    async postDescribeViral() {
      this.dialogPageInsight = !this.dialogPageInsight;
      if (this.listIndexOpenInsight[this.listIndexOpenInsight.length - 1] != false) {
        this.listResponseDescribeDashboard = [];
        this.currentLoadingIndex = 0;
        this.listIndexOpenInsight[this.indexOpenInsight] = false;
        this.indexOpenInsight += 1;

        this.loadingResponseDescribeDashboard = true;
        try {
          const token = localStorage.getItem('token_app');

          try {
            const decodeResponse = await axios.post("decode-token", { token });

            if (!decodeResponse.data.valid) {
              throw { response: { status: 403 } };
            }
          } catch (e) {
            this.loadingResponseDescribeDashboard = false;
            const { status } = e.response || {};

            switch (status) {
              case 404:
                this.$refs.alert.error_login(404);
                break;
              case 403:
                this.$refs.alert.error_login(403);
                break;
              default:
                console.log("some other error");
                break;
            }
            return;
          }

          const axiosInstance = axios.create({
            baseURL: "/apigenerativeAI",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');

          const payload = {
            topic: this.searchContextTopic,
            period: periode,
            sentiment: "All",
            chosen_tag_cloud: [],
          };

          const response = await axiosInstance.post(
            "/gen-ai-medan/api/v1/chat/describe-trending-topic",
            payload
          );

          const combinedText =
            (response.data.data.tag_cloud_news?.response || '') +
            '\n\n' +
            (response.data.data.tag_cloud_socmed?.response || '');

          const lines = combinedText.replace(/\r/g, '').split('\n');
          this.listResponseDescribeDashboard = [];

          let currentSection = "";
          let isInRincianKonten = false;

          lines.forEach((line, index) => {
            const trimmed = line.trim();
            if (!trimmed) return;

            const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
            if (headingMatch) {
              const level = headingMatch[1].length;
              const headingText = headingMatch[2];

              if (level == 2 && headingText.includes("Rincian Konten")) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                }
                currentSection = trimmed;
                isInRincianKonten = true;
              } else if (
                isInRincianKonten &&
                level == 3 &&
                (
                  headingText.includes("Konten Positif") ||
                  headingText.includes("Konten Negatif") ||
                  headingText.includes("Konten Netral")
                )
              ) {
                currentSection += '\n' + trimmed;
              } else if (level <= 2) {
                if (currentSection) {
                  this.listResponseDescribeDashboard.push(currentSection.trim());
                  currentSection = "";
                }
                currentSection = trimmed;
                isInRincianKonten = false;
              } else {
                currentSection += '\n' + trimmed;
              }
            } else {
              currentSection += '\n' + trimmed;
            }

            if (index == lines.length - 1 && currentSection) {
              this.listResponseDescribeDashboard.push(currentSection.trim());
            }
          });

          const totalItems = this.listResponseDescribeDashboard.length;
          const interval = setInterval(() => {
            this.currentLoadingIndex++;
            if (this.currentLoadingIndex >= totalItems) {
              clearInterval(interval);
              this.loadingResponseDescribeDashboard = false;
            }
          }, 500);
        } catch (error) {
          console.error("Error in postDescribeViral:", error);
          this.loadingResponseDescribeDashboard = false;
          this.listResponseDescribeDashboard = ["The server is busy. Please try again later."];
        }
      }
    },
    formatTextDescribeDashboard(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        if (trimmed.startsWith('- **') && trimmed.includes('**:')) {
          const match = trimmed.match(/^- \*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const boldText = match[1];
            const content = match[2];
            htmlOutput += `<p style="margin-bottom: 2px;">- ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        if (/^\d+\.\s+\*\*/.test(trimmed) && trimmed.includes('**:')) {
          const match = trimmed.match(/^(\d+\.)\s+\*\*(.+?)\*\*:\s*(.*)$/);
          if (match) {
            const number = match[1];
            const boldText = match[2];
            const content = match[3];
            htmlOutput += `<p style="margin-bottom: 2px;">${number} ${boldText}:</p>`;
            if (content) {
              htmlOutput += `<p style="margin-bottom: 2px;">${content}</p>`;
            }
            return;
          }
        }

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level}>${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 0px;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    async loadTopic() {
      this.currentOrigin = `${window.location.protocol}//${window.location.hostname}`;
      this.isSearch = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        if (!data || data.length == 0) {
          this.listSourceCollection = collections
            .filter(item => item.NAME_COLLECTION != 'mediaonline')
            .sort((a, b) => {
              const order = ['twitter', 'instagram', 'youtube', 'tiktok', 'facebook'];
              return order.indexOf(a.NAME_COLLECTION) - order.indexOf(b.NAME_COLLECTION);
            });
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
          return;
        }

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob === undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }
            this.searchContextTopic = data[i].TOPIC;
          }
        }

        this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
          text: keyword,
          value: keyword,
          disabled: index != 0,
        }));

        this.isShowDate = this.$store.is_show_date_glob;
        var fromDate = this.startDate;
        var untilDate = this.endDate;

        if (this.$store.jenis_parameter_glob == "custom") {
          fromDate = this.$store.date_start_glob;
          untilDate = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let dateGenerate = generateFilterDate(periode);
          fromDate = dateGenerate.start_date;
          untilDate = dateGenerate.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob === undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: fromDate,
            date_end_glob: untilDate,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.startDate = this.$store.date_start_glob;
          this.endDate = this.$store.date_end_glob;
        }

        this.listSourceCollection = dataDecryption.collection
          .filter(item => item.NAME_COLLECTION != 'mediaonline')
          .sort((a, b) => {
            const order = ['twitter', 'instagram', 'youtube', 'tiktok', 'facebook'];
            return order.indexOf(a.NAME_COLLECTION) - order.indexOf(b.NAME_COLLECTION);
          });

        if (data.length > 0) {
          this.loadViral();
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
        }

        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let dateGenerate = generateFilterDate(periode);
        fromDate = dateGenerate.start_date;
        untilDate = dateGenerate.end_date;
        this.startDate = fromDate;
        this.endDate = untilDate;

        this.searchContextStartDate = this.startDate;
        this.searchContextEndDate = this.endDate;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.isSearch = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    openDialogSearchContext() {
      for (let i = 0; i < this.topicSentiment.length; i++) {
        if (this.topicSentiment[i].SEQ_ID == this.$store.topic_glob) {
          this.searchContextTopic = this.topicSentiment[i].TOPIC;
        }
      }

      this.dialogSearchContext = true;
      setTimeout(() => {
        this.dialogSearchContext = false;
      }, 10000);
    },
    async parameterProsesTopic() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }

          this.topicKeywordSentiment = this.topicKeywordSentiment.map((keyword, index) => ({
            text: keyword,
            value: keyword,
            disabled: index != 0,
          }));
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesKeyword() {
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesPeriode() {
      let fromDate = this.startDate;
      let untilDate = this.endDate;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let dateGenerate = generateFilterDate(periode);
        fromDate = dateGenerate.start_date;
        untilDate = dateGenerate.end_date;
        this.startDate = fromDate;
        this.endDate = untilDate;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });

      this.searchContextStartDate = fromDate;
      this.searchContextEndDate = untilDate;
      this.showPeriodeDate();
    },
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.startDate);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showStartDate = dateString;

      var date3 = new Date(this.endDate);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showEndDate = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.startDate,
        date_end_glob: this.endDate,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";
      var fromDate = this.startDate;
      var untilDate = this.endDate;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: fromDate,
        date_end_glob: untilDate,
        is_show_date_glob: this.isShowDate
      });
    },
  }
}
</script>

<style scoped>
::v-deep .apexcharts-pie-area {
  opacity: 1;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
::v-deep .apexcharts-slices:hover .apexcharts-pie-area:not(:hover) {
  opacity: 0.3 !important;
  transition: opacity 0.3s ease;
}
::v-deep .apexcharts-slices .apexcharts-pie-area:hover {
  opacity: 1 !important;
  transition: opacity 0.3s ease;
  filter: brightness(1.15) drop-shadow(0 0 8px rgba(0,0,0,0.2));
}
::v-deep .apexcharts-datalabels,
::v-deep .apexcharts-datalabel,
::v-deep .apexcharts-datalabel-label,
::v-deep .apexcharts-datalabel-value {
  opacity: 1 !important;
  pointer-events: none;
}
.hashtags-chart-wrapper {
  width: 100%;
  max-width: 100%;
}
.wordcloud-class {
  display: flex;
  align-items: flex-start;
  max-height: 380px !important;
  min-width: 150px !important;
  margin-top: -20px !important;
}
.wordcloud-class >>> text {
  cursor: default;
}
.bubble-container {
  position: relative;
  margin: 0 auto;
  height: 400px;
  width: 400px;
}
.bubble {
  position: absolute;
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;
}
.bubble:hover {
  transform: scale(1.1);
  z-index: 2;
}
.bubble-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.tooltip-mentions {
  position: fixed;
  background: white;
  color: black;
  pointer-events: none;
  font-size: 14px;
  line-height: 1.4;
  width: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  padding: 10px;
  z-index: 9999;
}
.semantic-container {
  position: relative;
  overflow: hidden;
  height: 420px;
  max-height: 420px;
  margin-right: 16px;
  margin-left: 16px;
}
.propagation-map-search-controls {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 10px;
  left: 10px;
  gap: 6px;
}
.search-node-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 4px;
}
.cluster-switch-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  gap: 4px;
  padding: 4px 6px;
}
.cluster-switch-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  cursor: pointer;
  user-select: none;
  font-weight: bold;
  font-size: 22px;
  height: 28px;
  width: 28px;
  border-radius: 6px;
  line-height: 1;
  padding-bottom: 2px;
}
.cluster-switch-label {
  color: #000;
  text-align: center;
  font-size: 13px;
  min-width: 36px;
}
.propagation-map-controls {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  top: 110px;
  left: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.map-control-btn {
  height: 32px;
  width: 32px;
  line-height: 32px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  color: #000000;
  border-bottom: 1px solid #e0e0e0;
  user-select: none;
}
.map-control-btn:last-child {
  border-bottom: none;
}
.propagation-map-search-controls-fullscreen {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 30px;
  left: 30px;
  gap: 6px;
}
.canvas-container {
  background-color: white;
  overflow: hidden;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
}
.semantic-loading-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.82);
  border-radius: 8px;
  inset: 0;
  z-index: 50;
}
.semantic-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  padding: 24px;
}
.semantic-loading-spinner {
  position: relative;
  height: 60px;
  width: 60px;
}
.spinner-ring {
  position: absolute;
  animation: spinRing 1.4s linear infinite;
  border: 3px solid transparent;
  border-radius: 50%;
  inset: 0;
}
.spinner-ring:nth-child(1) {
  animation-duration: 1.0s;
  border-top-color: #ffffff;
}
.spinner-ring:nth-child(2) {
  animation-duration: 1.4s;
  animation-direction: reverse;
  border-top-color: #aaaaaa;
  inset: 8px;
}
.spinner-ring:nth-child(3) {
  animation-duration: 1.8s;
  inset: 16px;
  border-top-color: #555555;
}
@keyframes spinRing {
  to { transform: rotate(360deg); }
}
.semantic-loading-title {
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.semantic-loading-subtitle {
  font-size: 12px;
  color: #bbbbbb;
}
.semantic-loading-steps {
  display: flex;
  color: #555555;
  transition: color 0.3s;
  font-size: 11px;
  gap: 12px;
}
.semantic-loading-steps span {
  transition: color 0.4s ease;
}
.semantic-loading-steps span.active {
  color: #ffffff;
}
.tooltip-propagation-map {
  display: flex;
  flex-direction: column;
  position: fixed;
  background: white;
  color: #333333;
  font-family: Roboto, sans-serif;
  pointer-events: none;
  overflow: hidden;
  font-size: 13px;
  max-height: 500px;
  max-width: 340px;
  min-width: 300px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;
  z-index: 50;
}
.tooltip-header {
  display: flex;
  align-items: flex-start;
  background: white;
  border-bottom: 1px solid #e1e8ed;
  flex-shrink: 0;
  gap: 12px;
  padding: 12px 16px;
}
.tooltip-avatar {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}
.tooltip-content {
  flex: 1;
  min-width: 0;
}
.tooltip-title-propagation-map {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 2px;
  color: #000000;
  word-wrap: break-word;
}
.tooltip-coordinate-propagation-map {
  font-size: 14px;
  margin-bottom: 0;
  color: #000000;
}
.tooltip-body {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
  min-height: 0;
  flex: 1;
}
.viral-posts-container {
  padding: 0;
}
.viral-post-item {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  padding: 12px 16px;
}
.viral-post-item:last-child {
  border-bottom: none;
}
.post-header {
  display: flex;
  gap: 10px;
  margin-bottom: 4px;
}
.post-avatar {
  object-fit: cover;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}
.post-info {
  flex: 1;
  min-width: 0;
}
.post-user {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 1.3;
  gap: 4px;
  margin-bottom: 4px;
}
.user-name {
  font-size: 15px;
  font-weight: 700;
  color: #14171a;
}
.v-icon.mdi-check-decagram {
  color: #1da1f2 !important;
  font-size: 16px !important;
}
.user-meta {
  font-size: 14px;
  font-weight: 400;
  color: #657786;
}
.post-text {
  color: #14171a;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 1.5;
  margin: 6px 0 10px 0;
}
.post-statistics {
  display: flex;
  color: #5b7083;
  font-size: 13px;
  margin-top: 8px;
  margin-left: 50px;
  gap: 24px;
}
.post-statistics-item {
  display: flex;
  align-items: center;
  font-weight: 400;
  gap: 4px;
}
.post-statistics-item span {
  font-size: 13px;
}
.post-statistics-icon {
  color: #5b7083 !important;
  font-size: 16px !important;
}
.post-divider {
  display: none;
}
@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.tooltip-propagation-map {
  animation: tooltipFadeIn 0.2s ease-out;
}
.propagation-fullscreen-overlay {
  background: #000000;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 9999;
}
.propagation-fullscreen-overlay:fullscreen {
  height: 100%;
  width: 100%;
}
.semantic-container-full-screen {
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.propagation-map-controls-full-screen {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  top: 90px;
  left: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  margin-top: 40px;
  margin-left: 20px;
  z-index: 10;
}
.map-control-btn-full-screen {
  height: 32px;
  width: 32px;
  line-height: 32px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  color: #000000;
  border-bottom: 1px solid #e0e0e0;
  user-select: none;
}
.map-control-btn-full-screen:last-child {
  border-bottom: none;
}
.canvas-container-full-screen {
  background-color: #000000;
  overflow: hidden;
  height: 120%;
  width: 100%;
  border-radius: 0.5rem;
}
.tooltip-propagation-map-full-screen {
  display: flex;
  flex-direction: column;
  position: fixed;
  background: white;
  color: #333333;
  font-family: Roboto, sans-serif;
  pointer-events: auto;
  overflow: hidden;
  font-size: 13px;
  max-height: 500px;
  max-width: 340px;
  min-width: 300px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0;
  z-index: 50;
}
.tooltip-propagation-map-full-screen .tooltip-header {
  display: flex;
  align-items: flex-start;
  background: white;
  border-bottom: 1px solid #e1e8ed;
  flex-shrink: 0;
  gap: 12px;
  padding: 12px 16px;
}
.tooltip-propagation-map-full-screen .tooltip-avatar {
  object-fit: cover;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  flex-shrink: 0;
}
.tooltip-propagation-map-full-screen .tooltip-content {
  flex: 1;
  min-width: 0;
}
.tooltip-title-propagation-map-full-screen {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  word-wrap: break-word;
  margin-bottom: 2px;
}
.tooltip-coordinate-propagation-map-full-screen {
  font-size: 14px;
  margin-bottom: 0;
  color: #000000;
}
@keyframes tooltipFadeInFullScreen {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.tooltip-propagation-map-full-screen {
  animation: tooltipFadeInFullScreen 0.2s ease-out;
}
.rotate-animation {
  animation: rotateFrom90 1s linear;
}
@keyframes rotateFrom90 {
  from {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(-450deg);
  }
}
.loading-dots {
  color: var(--color-theme);
  font-size: 32px;
  font-weight: bold;
  display: inline-flex;
}
.loading-dots span {
  animation: blink 1.5s infinite;
  margin: 0 2px;
}
.loading-dots span:nth-child(1) { animation-delay: 0s; }
.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}
.response-text-describe-viral {
  display: block;
  background: #f4f4f4;
  color: #2e2e2e;
  white-space: pre-wrap;
  overflow-x: auto;
  max-height: 100%;
  max-width: 100%;
  border-radius: 8px;
  line-height: 1.6;
  padding: 10px;
}
.response-text-describe-viral strong {
  display: block;
  margin-bottom: 4px;
}
.response-text-describe-viral ul {
  margin-top: 4px;
  padding-left: 20px;
}
.btn-close-dialog-search-context {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  margin-left: auto;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}
</style>

<style>
.wordcloud-class div.tooltip,
.wordcloud-class ~ div.tooltip,
div.tooltip:not(.v-tooltip__content) {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  font: 16px Arial !important;
  pointer-events: none;
  height: auto !important;
  min-width: 150px !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  line-height: 18px !important;
  padding: 8px !important;
}
.wordcloud-class .tooltip .tooltip-inner,
div.tooltip:not(.v-tooltip__content) .tooltip-inner {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  width: 100px !important;
  max-width: 100px !important;
}
</style>
